<template xmlns:>
  <div style="margin:15px 0px;">
    <!--    温馨提示-->
    <!--    <div class="reminder_div oneFunction_div">-->
    <!--      <div class="reminder_title">-->
    <!--        <span style="color: rgb(72, 149, 210);">温馨提示</span>-->

    <!--      </div>-->
    <!--      <div class="reminder_content">-->
    <!--        <div v-show="hasAuth">-->
    <!--          <span style="line-height: 26px"><span class="asterisk">*</span>您已订购本库，如有任何疑问，请联系我们</span>-->
    <!--        </div>-->
    <!--        <div v-show="!hasAuth">-->
    <!--          <span style="line-height: 26px">-->
    <!--            <span class="asterisk">*</span>-->
    <!--            <span style="color: red; font-weight: bold;">您目前处于试用阶段</span>，您可以预览和下载本库的部分正式数据，如需更多数据，请联系我们-->
    <!--          </span>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <span style="line-height: 26px"><span class="asterisk">*</span>更多数据库详情，请点击样本与字段说明，数据库说明</span>-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <span style="line-height: 26px"><span class="asterisk">*</span>使用本库数据，请添加引用：数据来源于爱文本-智能文本分析系统</span>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--    </div>-->

    <div class="alertclass">
      <Alert>
        温馨提示
        <template slot="desc">
          <div style="margin: 16px 28px; margin-bottom: 0px;">
            <div v-show="AuthLevel===3">
              <span style="line-height: 26px"><span class="asterisk">*</span>您已订购本库，如有任何疑问，请<a href="#contact"
                                                                                               data-toggle="modal"
                                                                                               data-target=".contactUs">联系我们</a></span>
            </div>
            <div v-show="AuthLevel===1">
          <span style="line-height: 26px">
            <span class="asterisk">*</span>
            <span style="color: red; font-weight: bold;">您目前处于试用阶段</span>，您可以预览和下载本库的部分<span
              style="color: red; font-weight: bold;">样本数据</span>，如需更多数据，请<a href="#contact" data-toggle="modal"
                                                                            data-target=".contactUs">联系我们</a>
          </span>
            </div>
            <div v-show="AuthLevel===2">
          <span style="line-height: 26px">
            <span class="asterisk">*</span>
            <span style="color: red; font-weight: bold;">您目前处于试用阶段</span>，您可以预览和下载本库的部分<span
              style="color: red; font-weight: bold;">高级试用数据</span>，如需更多数据，请<a href="#contact" data-toggle="modal"
                                                                              data-target=".contactUs">联系我们</a>
          </span>
            </div>
            <div>
              <span style="line-height: 26px"><span class="asterisk">*</span>更多数据库详情，请点击<a
                  @click="changeModelCard('FieldInfoAndSimpleData')">样本与字段说明</a>，<a @click="changeModelCard('DBIntro')">数据库说明</a></span>
            </div>
            <div>
              <span style="line-height: 26px"><span class="asterisk">*</span>使用本库数据，请添加引用：数据来源于爱文本-智能文本分析系统</span>
            </div>
          </div>
        </template>
      </Alert>
    </div>
    <!--    温馨提示结束-->
    <!--时间范围-->
    <div class="reminder_div oneFunction_div">
      <div class="reminder_title">
        <i class="iconfont icon-shijianfanwei"></i>
        <span>时间范围</span>
      </div>
      <div class="reminder_content" style="height: 110px;margin-bottom: 15px;">
        <div style="overflow:hidden;display:flex;align-items:center;">
          <div class="radio-primary" style="float:left;margin-bottom: 10px;">
            <input type="radio"
                   :disabled="(!currentTableInfo.hasYear)||(AuthLevel===1)||(AuthLevel===2)"
                   value="ByYear"
                   v-model="timeSelect"
                   name="timeSelect"
                   id="customYear">
            <label for="customYear">选择年份</label>
          </div>
          <div class="timepicker-div" style="width: 262px">
            <div class="Yearselect" style="border: 1px solid rgba(223, 229, 240, 0.8);border-radius: 3px;height: 35px;">
              <div class="timepicker-header">
                <span style="font-size: 11px;color: #ccc;"><i class="iconfont icon-nian"></i></span>
              </div>
              <Select v-model="selectYear[0]"
                      :max-tag-count="1"
                      placeholder="请选择年份"
                      :disabled="timeSelect!=='ByYear'">
                <Option v-for="item in yearList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
              <button class="clearoptions" :class="{yearButton : selectYear.length === 0}" @click="removeAllYear">
                <i class="iconfont icon-lajitong clearoi" style="font-size: 13px;color: #c7c8d0;margin-right: 0px"></i>
                清空
              </button>
            </div>
          </div>
        </div>
        <!--        <div style="overflow:hidden;display:flex;align-items:center;">-->
        <!--          <div class="radio-primary" style="float:left;margin-bottom: 10px;" @click="">-->
        <!--            <input type="radio"-->
        <!--                   value="Custom"-->
        <!--                   :disabled="!currentTableInfo.hasDate"-->
        <!--                   v-model="timeSelect"-->
        <!--                   name="timeSelect"-->
        <!--                   id="customTime" >-->
        <!--            <label for="customTime">时间区间</label>-->
        <!--          </div>-->
        <!--          <div class="timepicker-div">-->
        <!--            <div class="timepicker">-->
        <!--              <div class="timepicker-header">-->
        <!--                <span style="font-size: 11px;color: #ccc;">开始</span>-->
        <!--              </div>-->
        <!--              <div class="timepicker-input">-->
        <!--                <datepicker placeholder="请选择起始日期"-->
        <!--                            :disabled="timeSelect!=='Custom'"-->
        <!--                            el="startDate"-->
        <!--                            :mindate="minDate" defalutdate-->
        <!--                            autocomplete="off">-->
        <!--                </datepicker>-->
        <!--&lt;!&ndash;                <span class="iconfont icon-riqi"></span>&ndash;&gt;-->
        <!--                <Icon class="ivicon" type="ios-calendar-outline" />-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="timepicker" style="margin-left:20px;">-->
        <!--              <div class="timepicker-header">-->
        <!--                <span style="font-size: 11px;color: #ccc;">结束</span>-->
        <!--              </div>-->
        <!--              <div class="timepicker-input">-->
        <!--                <datepicker placeholder="请选择结束日期"-->
        <!--                            :disabled="timeSelect!=='Custom'"-->
        <!--                            el="enddate"-->
        <!--                            :mindate="minDate" defalutdate-->
        <!--                            autocomplete="off">-->
        <!--                </datepicker>-->
        <!--&lt;!&ndash;                <span class="iconfont icon-riqi"></span>&ndash;&gt;-->
        <!--                <Icon class="ivicon" type="ios-calendar-outline" />-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div style="height:35px;display:flex;">
          <div class="radio-primary">
            <input type="radio"
                   value="NoLimit"
                   v-model="timeSelect"
                   name="timeSelect"
                   id="nolimit">
            <label for="nolimit">时间不限</label>
          </div>
        </div>
        <p class="tip">
          <span class="tipleft">
            本表以
            <span class="underline">[统计日期]</span>
            字段为时间查询基准
          </span>
          <!--<span class="tipright" v-if="currentTableInfo.hasYear">-->
          <!--  本数据库数据开始年份：-->
          <!--  <span class="underline">{{ currentTableInfo.startyear }}</span>-->
          <!--</span>-->
        </p>
      </div>
    </div>
    <!--时间范围结束 -->

    <!--代码设置-->
    <!--    <div class="reminder_div oneFunction_div" v-if="currentTableInfo.hasCode">
          <div class="reminder_title">
            <i class="iconfont icon-hebingxingzhuang12x"></i>
            <span style="vertical-align: unset;">代码设置</span>
          </div>
          <div class="reminder_content">
            <div class="codeSelect_model_select_div">
              &lt;!&ndash;全部代码&ndash;&gt;
              <div>
                <div class="radio-primary">
                  <input type="radio"
                         value="SelectAll"
                         v-model="stockCodeSelect"
                         name="stockCodeSelect"
                         id="allStockCode">
                  <label for="allStockCode">全部代码</label>
                </div>
              </div>
              &lt;!&ndash;代码选择&ndash;&gt;
              <div>
                <div class="radio-primary">
                  <input type="radio"
                         value="Other"
                         v-model="stockCodeSelect"
                         name="stockCodeSelect"
                         id="selectStockCode">
                  <label for="selectStockCode">代码选择</label>
                </div>
              </div>

              &lt;!&ndash;代码选择穿梭框&ndash;&gt;
              <transition v-on:enter="enter" v-on:leave="leave" v-bind:css="false">
                <div
                    v-if="stockCodeSelect=='Other'"
                    class="stockCodeSelect_inputAndButton_div"
                    style="padding:5px 0px 10px 0px;padding-bottom: 15px;"
                >
                  <div class="stockCodeSelect_select_body">
                    <Alert show-icon>
                      <Icon type="md-bulb" slot="icon"></Icon>
                      点击待选代码选定，点击已选代码删除
                    </Alert>
                    <div class="all_stockCode_name_div">
                      <div class="select_head_div">
                        <span>待选：</span>
                        <span style="font-size: 12px;margin-left: 35px;color:rgba(223, 229, 240, 0.4)!important;">证券代码 -&#45;&#45; 证券简称</span>
                      </div>
                      <div class="field-select-search">
                        <input @focus="stockCodeSelect_serach=''"
                               placeholder="搜索证券代码或简称"
                               v-model="stockCodeUnSelect_serach"/>
                        <span class="iconfont icon-search"></span>
                      </div>
                      <div class="stockCode_name_body_div scrollbar-hover scrollbars">
                        <div v-show="stock_loading" class="stock_loading_div">
                          <i class="icon icon-spin icon-spinner-snake icon-3x"></i>
                        </div>
                        <template v-if="showstockcodediv">
                          <div v-if="sortStockCodeArray[0].code!='none'">
                            <div
                                v-for="data in sortStockCodeArray"
                                class="oneSelectOption_div"
                                @click="addOneOptionToSelected(data)"
                                :key="data.code"
                            >
                              <div style="width:120px;height:100%;margin:0 auto;text-align:left;">
                                <span>{{ data.code }} -&#45;&#45;</span>
                                <span>{{ data.name }}</span>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div
                                v-for="data in sortStockCodeArray"
                                class="oneSelectOption_div"
                                :key="data.code"
                                style="cursor:not-allowed;"
                            >
                              <div style="width:120px;height:100%;margin:0 auto;text-align:left;">
                                <span>{{ data.name }}</span>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="iconfont icon-jiaohuan">
                      &lt;!&ndash;<i style="font-size:24px;" class="icon icon-chevron-right"></i>&ndash;&gt;
                    </div>
                    <div class="stockCode_selected_div" style="float:right">
                      <div class="select_head_div">
                        <span>已选代码：</span>
                        <div @click="removeAllStockCode" class="removeAllStock_div">
                          <span style="position:relative;top:-4px;">删除全部</span>
                        </div>
                      </div>
                      <div class="field-select-search">
                        <input
                            @focus="stockCodeUnSelect_serach=''"
                            placeholder="搜索证券代码或简称"
                            v-model="stockCodeSelect_serach"
                        />
                        <span class="iconfont icon-search"></span>
                      </div>
                      <div class="selected_body_div scrollbar-hover scrollbars">
                        <template v-if="sortSelectedStockCodeArray.length==1">
                          <template v-if="sortSelectedStockCodeArray[0].code!='none'">
                            <div
                                v-for="data in sortSelectedStockCodeArray"
                                class="oneSelectedOption_div"
                                @click="removeOneOption(data)"
                                :key="data.code"
                            >
                              <div style="width:120px;height:100%;margin:0 auto;text-align:left;">
                                <span v-if="data.code!='none'">{{ data.code }} -&#45;&#45;</span>
                                <span>{{ data.name }}</span>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <div
                                v-for="data in sortSelectedStockCodeArray"
                                class="oneSelectOption_div"
                                :key="data.code"
                                style="cursor:not-allowed;"
                            >
                              <div style="width:120px;height:100%;margin:0 auto;text-align:left;">
                                <span>{{ data.name }}</span>
                              </div>
                            </div>
                          </template>
                        </template>
                        <template v-else>
                          <div
                              v-for="data in sortSelectedStockCodeArray"
                              class="oneSelectedOption_div"
                              @click="removeOneOption(data)"
                              :key="data.code"
                          >
                            <div style="width:120px;height:100%;margin:0 auto;text-align:left;">
                              <span v-if="data.code!='none'">{{ data.code }} -&#45;&#45;</span>
                              <span>{{ data.name }}</span>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            &lt;!&ndash;代码导入&ndash;&gt;
            <div class="code-import-div">
              <div>
                <div class="radio-primary">
                  <input type="radio"
                         value="Upload"
                         v-model="stockCodeSelect"
                         name="stockCodeSelect"
                         id="stockCodeInput">
                  <label for="stockCodeInput">代码导入</label>
                </div>
              </div>
              &lt;!&ndash;导入模块&ndash;&gt;
              <div class="stockCodeInput_inputAndButton_div">
                <div class="downloadtemplate">
                  <a href="/CodeTemplate.zip">
                      <span style="cursor:pointer;">
                        <Icon type="ios-cloud-download-outline" style="font-size: 16px;font-weight: 700;margin: 0px 1px;"/>
                        模板下载
                      </span>
                  </a>
                </div>
                <Upload
                    type="drag"
                    ref="uploadcode"
                    action="/api/UploadFile"
                    :format="['txt','xlsx','xls']"
                    :max-size="1024"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadErr"
                    :before-upload="handleBeforeUpload"
                    :on-format-error="handleUploadFormat"
                >
                  <div style="padding: 20px 0">
                    <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                    <p>点击选择或拖曳至此区域上传文件</p>
                    <p style="font-size: 80%;color: #bfbfbf;">请选择大小不超过 1M 的文本文件<br/>（支持.txt .xls .xlsx格式）</p>
                  </div>
                </Upload>

                &lt;!&ndash;            </form>&ndash;&gt;
              </div>
            </div>
          </div>
        </div>-->
    <!--代码设置结束-->
    <!--关键词-->
    <div
        v-if="$route.params.name=='cipin'"
        class="reminder_div oneFunction_div"
        style="min-height: 350px;">
      <div class="reminder_title">
        <i class="iconfont icon-guanjianci1"></i>
        <span>关键词</span>
      </div>
      <div class="setTime_body_div">
        <div class="cipindiv reminder_content">
          <input
              id="keywordsinput"
              v-model="keyword"
              placeholder="请输入两个或两个以上字符的中文词汇，例如“风险”,“现金流”,以英文逗号','分隔。"/>
          <button @click="keyWordQuery" class="commonbtn inquirebtn">
            <i class="iconfont icon-search"
               style="vertical-align: middle;font-size: 16px; margin: 0px;color: white;"></i>
            查询
          </button>

          <iframe id="UploadIframe" name="UploadIframe" style="display:none" @load="showUploadInfo"></iframe>
          <form target="UploadIframe" id="uploadFile_form" enctype="multipart/form-data" method="post"
                action="/api/UploadKeywordsFile" style="display:inline">
            <!--            <input id="uploadfile" @change="uploadFileChange" style="display: none" type="file"  name="files">-->
            <input id="uploadfile" @change="uploadFileChange" style="display: none" type="file" name="files">
            <button @click.prevent="uploadThisFile" class="commonbtn inquirebtn2">
              <i class="el-icon-circle-plus-outline"
                 style="vertical-align: middle;font-size: 16px; margin: 0px;color: white;"></i>
              打开关键词文件
            </button>
          </form>

          <button @click="keyWordDownload" class="commonbtn inquirebtn3">
            <i class="el-icon-download"
               style="vertical-align: middle;font-size: 16px; margin: 0px;color: white;"></i>
            模板
          </button>
          <div style="margin-left:10px;display:inline-block;vertical-align:top;float: right;">
            <iframe
                id="UploadIframeKeywords"
                name="UploadIframeKeywords"
                style="display:none"
                @load="showUploadKeywordsInfo"
            ></iframe>
            <form
                style="display:inline-block;"
                target="UploadIframeKeywords"
                id="uploadKeywordsFile_form"
                enctype="multipart/form-data"
                action="/api/UploadKeywordsFile"
                method="post"
            >
              <input
                  id="uploadkeywordsfile"
                  @change="uploadKeywordsFile"
                  v-if="AuthLevel !==1&&AuthLevel!==2"
                  type="file"
                  style="display:none;"
                  name="files"
              />
              <!--              <label
                                for="uploadkeywordsfile"
                                class="add-keywords-button"
                                @click="clearKeywordsFileInput"
                                title="选择文件"
                            >
                              <Icon type="ios-cloud-upload-outline"
                                    style="margin-right: 2px;font-weight: 600;margin-left: -2px;font-size: 14px;vertical-align: middle;"/>
                              批量导入关键词
                            </label>-->
            </form>
            <!--            <div class="add-keywords-button" style="margin-left:10px;width: 90px;margin-right: 0px;">
                          <a href="/KeywordsTemplate.zip" style="color: inherit">
                            <span style="cursor: pointer;">
                              <i class="ivu-icon ivu-icon-ios-cloud-download-outline"
                                 style="font-size: 14px; font-weight: 700; margin: 0px 1px;vertical-align: middle;"></i>
                              模板下载
                            </span>
                          </a>
                        </div>-->
          </div>
        </div>
      </div>
      <div style="margin: 20px 45px 0;clear:both;">
        <div>
          <div class="sampleData_table_div">
            <div v-if="headerList.length==0"
                 style="text-align:center;width:100%;height:50px;font-size:14px;margin-top: 78px;color: rgba(60, 90, 152,.5)">
              <div v-show="!dataload">
                <i class="iconfont icon-kulian" style="font-size: 36px;color: rgba(60, 90, 152,.5)"></i>
                <p>当前查询条件下暂无数据</p>
              </div>
              <Col class="demo-spin-col" style="rgba(60, 90, 152,.5)" v-show="dataload">
                <Spin fix>
                  <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                  <div>Loading</div>
                </Spin>
              </Col>
            </div>
            <div v-else>
              <Col class="demo-spin-col" style="rgba(60, 90, 152,.5)" v-show="dataload">
                <Spin fix>
                  <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                  <div>Loading</div>
                </Spin>
              </Col>
              <div v-show="!dataload">
                <div style="overflow: auto" class="scrollbars">
                  <table class="simpledata_table table-bordered hoverline" cellspacing="0" cellpadding="0">
                    <thead class="theadDivBox">
                    <tr v-if="headerList.length>0" style="background-color: #FFF;">
                      <th>序号</th>
                      <th v-for="(item) in headerList1" :key="item">{{ item }}</th>
                    </tr>
                    </thead>
                    <tbody class="tbodyDiv">
                    <tr v-for="(item,index) in this.simpleData" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td v-for="(item1) in headerList" :key="item1">
                        <span v-if="!((simpleData[index])[item1])"></span>
                        <span
                            v-if="(typeof ((simpleData[index])[item1])!='string') || item1.constructor!=String"
                        >{{ ((simpleData[index])[item1]) }}</span>
                        <span
                            v-else-if="((simpleData[index])[item1]).length<30"
                        >{{ ((simpleData[index])[item1]) }}</span>
                        <a
                            class="colDetail"
                            @click="hideOtherPopover"
                            href="javascript:void(0);"
                            data-toggle="popover"
                            data-placement="bottom"
                            :data-content="((simpleData[index])[item1])"
                            v-else
                        >点击查看</a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="simpleData.length>=20" style="margin-top: 10px">
                  <Alert type="success" style="height: 34px;">
                    <i class="iconfont icon-yangben"
                       style="font-size: 16px;margin-left: -6px;margin-right: 6px;color: #19be6b"></i>
                    已为您显示所设置条件下前
                    <span style="color:#19be6b">{{ simpleData.length }}</span> 条预览数据，更多数据请下载后查看
                  </Alert>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--关键词结束-->
    <!--情感词典-->
    <div v-if="$route.params.name=='qinggan'" class="reminder_div oneFunction_div">
      <div class="reminder_title">
        <i class="iconfont icon-qingganfenxi"></i>
        <span>情感词典选择</span>
      </div>
      <div class="reminder_content">
        <div>
          <div>
            <div class="radio-primary">
              <input type="radio"
                     value="ZiDingYiDict"
                     v-model="dictSelect"
                     name="dictSelect"
                     id="ZiDingYiDict">
              <label for="ZiDingYiDict">爱文本情感词典</label>
            </div>
          </div>
          <div class="radio-primary">
            <input type="radio"
                   value="LMDict"
                   v-model="dictSelect"
                   name="dictSelect"
                   id="LMDict">
            <label for="LMDict">LM词典</label>
          </div>
        </div>
        <div>
          <div class="radio-primary">
            <input type="radio"
                   value="TaiDaDict"
                   v-model="dictSelect"
                   name="dictSelect"
                   id="TaiDaDict">
            <label for="TaiDaDict">台大情感词典</label>
          </div>
        </div>
      </div>
    </div>
    <!--情感词典结束-->
    <!--字段选择-->
    <div class="reminder_div oneFunction_div">
      <div class="reminder_title">
        <i class="iconfont icon-ziduan1"></i>
        <span>字段选择</span>
      </div>

      <div class="fieldSelect_body_div">
        <Alert closable show-icon>
          <Icon type="md-bulb" slot="icon"></Icon>
          点击待选字段选定，点击已选字段删除
        </Alert>
        <div class="fieldSelect_content_div" style="overflow:hidden;">
          <div class="field-select-unselect">
            <div class="field-select-header">
              <div style="float:left;line-height:30px;">
                <Icon type="ios-arrow-down" style="top:2px;position: relative;left: -2px;"/>
                <span>待选字段</span>
              </div>
              <button @click="selectAllField">
                <Icon type="md-checkbox-outline" style="font-size: 16px"/>
                全部选中
              </button>
            </div>
            <div class="field-select-search">
              <input @focus="select_serach=''" placeholder="搜索字段" v-model="unSelect_serach"/>
              <span class="iconfont icon-search"></span>
            </div>
            <ul class="field-select-fieldlist scrollbars">
              <template v-if="unselectedField.length===1">
                <template v-if="unselectedField[0].FieldName==='notResult'">
                  <li
                      v-for="item in unselectedField"
                      :key="item.FieldName"
                      style="cursor:not-allowed;"
                  >
                    <span>{{ item.DisplayName }}</span>
                  </li>
                </template>
                <template v-else>
                  <li
                      @click="selectThisField(item)"
                      v-for="item in unselectedField"
                      :key="item.FieldName"
                  >
                    <span>{{ item.DisplayName }}</span>
                  </li>
                </template>
              </template>
              <template v-else>
                <li
                    @click="selectThisField(item)"
                    v-for="item in unselectedField"
                    :key="item.FieldName"
                >
                  <span>{{ item.DisplayName }}</span>
                </li>
              </template>
            </ul>
          </div>
          <div style="height:297px;width:1px;margin-left:15px;margin-top:45px;background:#ccc;"></div>
          <div class="field-select-selected">
            <div class="field-select-header">
              <div style="float:left;">
                <Icon type="ios-arrow-down" style="top:2px;position: relative;left: -2px;"/>
                <span>已选字段</span>
              </div>
              <button @click="removeAllField"><i class="iconfont icon-lajitong"
                                                 style="font-size: 14px;margin-right: 4px;color: #515a6e;font-weight: 600;"/>删除全部
              </button>
            </div>
            <div class="field-select-search">
              <input @focus="unSelect_serach=''" placeholder="搜索字段" v-model="select_serach"/>
              <span class="iconfont icon-search"></span>
            </div>
            <ul class="field-select-fieldlist scrollbars">
              <template v-if="selectedField.length==1">
                <template v-if="selectedField[0].FieldName=='notResult'">
                  <li
                      v-for="item in selectedField"
                      :key="item.FieldName"
                      style="cursor:not-allowed;"
                  >
                    <span>{{ item.DisplayName }}</span>
                  </li>
                </template>
                <template v-else>
                  <li
                      @click="removeThisField(item)"
                      v-for="item in selectedField"
                      :key="item.FieldName"
                  >
                    <span>{{ item.DisplayName }}</span>
                  </li>
                </template>
              </template>
              <template v-else>
                <li
                    @click="removeThisField(item)"
                    v-for="item in selectedField"
                    :key="item.FieldName"
                >
                  <span>{{ item.DisplayName }}</span>
                </li>
              </template>
            </ul>
          </div>
        </div>

      </div>
    </div>
    <!--字段选择结束-->
    <!--预览和下载-->
    <div class="table-footer">
      <Button
          id="previewbtn"
          @click="preview"
          icon="md-qr-scanner"
      ></Button>
      <Button
          id="bownloadbtn"
          @click="DownLoadM"
          icon="md-download"
          shape="circle"
      ></Button>
    </div>
    <!--提示对话框-->
    <div class="modal fade" id="errorInfoModal" tabindex="-1" role="dialog" aria-labelledby="errorInfoModal"
         aria-hidden="true">
      <div class="modal-dialog" style="width: 430px;background:transparent;">
        <div class="modal-content" style="border:0px;">
          <!--          <div class="modal-header" style="border-bottom: none">-->
          <!--            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" >-->
          <!--              &times;-->
          <!--            </button>-->
          <!--            <h4 class="modal-title">-->
          <!--              <span style="color:white;font-size:16px;">提示</span>-->
          <!--            </h4>-->
          <!--          </div>-->
          <div class="modal-body" style="background:white;border-radius: 6px;padding: 42px 20px 10px;">
            <div style="height:40px;padding:2px 0px;">
              <i class="iconfont icon-alert" style="font-size: 30px;vertical-align: middle;color:#4184f3"/>
              <span style="margin-left: 10px;font-size: 14px;display: inline-block;position: absolute;width: 350px;">{{
                  errorInfoArray
                }}</span>
            </div>
          </div>
          <div class="modal-footer"
               style="padding: 20px 15px 15px 0px;;background:white;border-top: none;border-radius: 6px;">
            <button type="button" @click="() => {this.dataload = false}" class="commonbtn" data-dismiss="modal"
                    style="width: 75px;height: 32px;outline:none;">知道了
            </button>
          </div>
        </div>
      </div>
    </div>


    <!--关键词确认框-->
    <Modal v-model="keyModel"
           ok-text="确定"
           cancel-text="取消"
           width="600"
           :closable="false"
           class-name="vertical-center-modal"
           @on-ok="keyDefine"
    >
      <p slot="header" style="color:#2D8CF0;text-align:center">
        <Icon type="ios-information-circle" style="margin-right: 4px"></Icon>
        <span>确认关键字统计</span>
      </p>
      <div style="padding:2px 0px;">
        <p>您所提供的词目前未收录，点击确定后，
          我们会采用云计算和人工智能技术为您在后台实时统计该次的词频。请在一个工作日之后点击"个人中心"下载。（试用用户关键字数量限定为5个）</p>
      </div>
    </Modal>
    <!--预览模态框-->
    <div class="modal fade" id="dataPreviewModal" tabindex="-1" role="dialog" aria-labelledby="dataPreviewModal"
         aria-hidden="true">
      <div class="modal-dialog" style="width: 1000px;background:transparent;">
        <div class="modal-content" style="border:0px;">
          <div class="modal-header"
               style="padding: 7px 15px;border-radius: 4px 4px 0 0;background: white;border-bottom: none;">
            <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                    style="font-size:26px;outline:none;color:#4773bb;font-weight: 500;opacity: .3;">
              &times;
            </button>
            <h4 class="modal-title">
              <i class="iconfont icon-sousuo"
                 style="color: #4773bb;font-size: 24px !important;vertical-align: middle;margin-right: 3px;"></i>
              <span style="color:#4773bb;font-size:16px;">数据预览</span>
            </h4>
          </div>
          <div class="modal-body" style="background:white;padding: 18px;padding-top: 0px;">
            <div v-if="previewLoading" class="PreviewLoading_div">
              <i class="icon icon-spin icon-spinner-snake icon-3x"></i>
            </div>
            <div v-else class="preview_sampleData_table_div  scrollbars">

              <div v-if="previewHeaderList.length==0"
                   style="color: rgba(60, 90, 152,.5) !important;text-align: center;width: 100%;font-size: 14px;padding-top: 50px;border-top: 1px solid #e5e5e5;padding-bottom: 50px;">
                <i class="iconfont icon-kulian" style="font-size: 36px;"></i>
                <p>当前查询条件下暂无数据</p>
              </div>
              <table v-else class="preview_simpledata_table stickythead table-bordered hoverline" cellspacing='0'
                     cellpadding='0'>
                <thead class="theadDivBox">
                <tr v-if="previewHeaderList.length>0" style="line-height: 32px;height: 32px;">
                  <th>序号</th>
                  <th v-for="(item) in previewHeaderList1" :key="item">{{ item }}</th>
                </tr>
                </thead>
                <tbody class="tbodyDiv">
                <tr v-for="(item,index) in this.previewData" :key="item.Word">
                  <td>{{ index + 1 }}</td>
                  <td v-for="(item1) in previewHeaderList" :key="item1">
                    <span v-if="previewData[index][item1] ? previewData[index][item1].toString().length<30 : true">{{
                        previewData[index][item1]
                      }}</span>
                    <a class="colDetail" @click="hideOtherPopover" href="javascript:void(0);" data-toggle="popover"
                       data-placement="bottom" :data-content="((previewData[index])[item1])" v-else>点击查看</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer" style="padding: 12px;padding-top:5px;background:white;border-radius: 0 0 4px 4px">
            <button type="button" @click="closePreviewDialog" class="commonbtn" data-dismiss="modal"
                    style="outline:none;float:right;overflow:hidden;width: 75px;height: 32px;">关闭
            </button>
            <!--            <div v-if="previewData.length>=100" style="text-align: center;margin-top:5px;">* 预览数据包含所设置条件下前-->
            <!--              <span style="color:blue;">{{previewData.length}}</span> 条数据，更多数据请下载后查看-->
            <!--            </div>-->
            <div v-if="previewData.length>=20">
              <Alert
                  style="height: 32px;margin-bottom: 0px;text-align: left;width: fit-content;font-size: 12px;padding: 0px 48px 0px 10px;line-height: 32px;">
                <i class="iconfont icon-yangben"
                   style="font-size: 16px;margin-left: -6px;margin-right: 2px;color: #2d8cf0;vertical-align: bottom;"></i>
                已为您显示所设置条件下前
                <span style="color:#2d8cf0">{{ previewData.length }}</span> 条预览数据，更多数据请下载后查看
              </Alert>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--用户权限对话框-->
    <div class="modal fade" id="roleInfoModal" tabindex="-1" role="dialog" aria-labelledby="roleInfoModal"
         aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog" style="width: 430px;background:transparent;">

        <div class="modal-content" style="border:0px;">
          <!--          <div class="modal-header">-->
          <!--            <button type="button" data-dismiss="modal" aria-hidden="true" class="close" style="font-size: 26px; outline: none; color: black;">-->
          <!--              ×-->
          <!--            </button>-->
          <!--            <h4 class="modal-title"><span style="color: black; font-size: 16px;">提示</span></h4>-->
          <!--          </div>-->
          <div class="modal-header" style="border-bottom: none;padding-bottom: 5px">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              &times;
            </button>
            <h4 class="modal-title">
              <span style="color:white;font-size:16px;">提示</span>
            </h4>
          </div>
          <div class="modal-body" style="background:white;border-radius: 6px;padding: 0px 20px 39px;">
            <div style="height:40px;padding:2px 0px;">
              <i class="iconfont icon-quanxian" style="font-size: 30px;vertical-align: middle;color:#4184f3"/>
              <span v-show="AuthLevel===1" style="margin-left:10px;font-size:14px;">您目前的登录状态下只能下载本库的 <span
                  style="color: #e52e5e">样本数据</span></span>
              <span v-show="AuthLevel===2" style="margin-left:10px;font-size:14px;">您目前的登录状态下只能下载本库的 <span
                  style="color: #e52e5e">高级试用数据</span></span>
              <p style="margin-left: 56px">如需下载正式数据，请<a href="#contact" data-toggle="modal" data-target=".contactUs">联系我们</a>或使用正式账号
                <a class="rolelogin" @click="gotoLogin">登录</a></p>
            </div>
          </div>
          <div class="modal-footer"
               v-show="showAuthModel"
               style="padding: 20px 15px 15px 0px;;background:white;border-top: none;border-radius: 6px;">
            <div style="float: left; margin-left: 12px;">
              <input id="noWarningCheck" type="checkbox"
                     style="position: relative; top: 2px; width: 14px; height: 14px; outline: none;">
              <label for="noWarningCheck"
                     style="font-weight: 500; cursor: pointer;font-size: 12px">&nbsp;本次登录不再提醒</label></div>
            <button type="button" class="commonbtn" data-dismiss="modal"
                    @click="asd"
                    style="width: 75px;height: 32px;outline:none;">继续下载
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--下载概要模态框-->
    <div class="modal fade" id="downloadSummaryModal" tabindex="-1" role="dialog" aria-labelledby="downloadSummaryModal"
         aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog" style="width: 1000px;background:transparent;">
        <div class="modal-content" style="border:0px;">
          <div class="modal-header" style="padding: 7px 15px;;border-radius: 4px 4px 0 0">
            <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                    style="font-size:26px;outline:none;color:#4773bb;font-weight: 500;opacity: .3;">
              &times;
            </button>
            <h4 class="modal-title">
              <i class="iconfont icon-gaiyao"
                 style="color: #4773bb;font-size: 24px !important;vertical-align: middle;margin-right: 3px;"></i>
              <span style="color:#4773bb;font-size:16px;">下载概要</span>
            </h4>
          </div>
          <div class="modal-body" style="background:white;overflow:auto;">
            <div class="downloadSummary_div">
              <div class="downloadSummary_table_div">
                <!--                test-->
                <table style="width: 100%;">
                  <tbody>
                  <tr style="border-bottom: 1px solid rgba(223, 229, 240, 0.8);">
                    <th class="title_td" colspan="1">下载表名：</th>
                    <td class="value_td" colspan="1">{{ getDownloadTable }}</td>
                    <th class="title_td" colspan="1">时间范围：</th>
                    <td class="value_td" colspan="1">{{ this.$route.query.year }}</td>
                    <th class="title_td" colspan="1">股票代码：</th>
                    <td class="value_td" colspan="1">
                      {{ this.$route.query.code === "股票代码" ? "暂未选择 " : this.$route.query.code }}
                    </td>
                    <th class="title_td" colspan="1">输出类型：</th>
                    <td class="value_td" colspan="1">{{ "Xlsx" | fileTypeFilter }}</td>
                  </tr>
                  <tr style="border-bottom: 1px solid rgba(223, 229, 240, 0.8);">
                    <th class="title_td" colspan="1">代码设置：</th>
                    <td class="value_td" colspan="5">{{ stockCodeComputed }}</td>
                  </tr>
                  <tr style="border-bottom: 1px solid rgba(223, 229, 240, 0.8);">
                    <th class="title_td" colspan="1">字段选择：</th>
                    <td class="value_td" colspan="5">
                      <span v-for='item in selectedField'
                            :key="item.FieldName">{{ item.DisplayName }}
                        <span>
                          [{{ item.FieldName }}]
                        </span>&nbsp;
                      </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div class="download_bottomInfo_div">
                  <div style="float:left;line-height:34px;">
                      <input type="checkbox" id="sendEmail_checkbox" style="width:15px;height:15px;position:relative;top:3px;" v-model='sendEmail_checkbox'>
                      <label for="sendEmail_checkbox" style="cursor:pointer;font-weight:500;">发送下载链接到邮箱</label>
                  </div>
                  <div style="float:left;margin-left:20px;">
                      <input v-model="email" disabled type="text" class="form-control email_input" placeholder="请输入邮箱地址" style="width:300px;">
                  </div>
                  <div class="sendEmailSuccess_div" style="float:left;margin-left:20px;line-height:34px;display:none;">
                      <i style="color:#5EB346;" class="icon icon-check-circle"></i>
                      <span style="color:#5EB346;">已发送下载链接至邮箱</span>
                  </div>
              </div> -->
            </div>
          </div>
          <div class="modal-footer" style="padding: 2px 18px;background:white;border-radius: 4px">
            <div class="addToDownList">
              <button class="download_button commonbtnol" @click="AddDownloadTask">
                <Icon type="md-download"/>
                添加到下载队列
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 下载模态框 -->
    <div class="modal fade" id="dataDownloadModal" tabindex="-1" role="dialog" aria-labelledby="dataDownloadModal"
         aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog" style="width: 1000px;background:transparent;">
        <div class="modal-content" style="border:0px;">
          <div class="modal-header" style="padding: 7px 15px;background:#fff;border-radius: 4px 4px 0 0;">
            <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                    style="font-size:26px;outline:none;color:rgb(71, 115, 187);">
              &times;
            </button>
            <h4 class="modal-title">
              <i class="iconfont icon-xiazai" STYLE="color: #4184f3;font-size: 20px;vertical-align: middle;"></i>
              <span style="font-size:16px;color: rgb(71, 115, 187)"> 下载进度</span>
            </h4>
          </div>
          <div class="modal-body aaaa" style="background:white;padding: 60px 75px 75px 60px;">
            <Steps :current="downloadCurrentStep" class="ivustep">
              <Step title="已提交" content="下载任务已提交">
              </Step>
              <Step title="查询中">
                <div slot="icon" v-if="downloadPercentage <= 1" style="width: 24px">
                  <Spin fix>
                    <div class="loader">
                      <svg class="circular" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" r="20" fill="none" :stroke-width=5
                                stroke-miterlimit="10"></circle>
                      </svg>
                    </div>
                  </Spin>
                </div>
                <div slot="content">
                  <span v-show="downloadPercentage <= 1">正在查询，请稍候...</span>
                  <span v-show="downloadPercentage > 1">数据查询完成</span>
                </div>
              </Step>
              <Step title="转换中">
                <div slot="title">
                  <span>转换中</span>
                </div>
                <div slot="content">
                  <span v-if="downloadPercentage !== 100">文件正在转换
                    <span>{{ downloadPercentage }}%</span>
                  </span>
                  <span v-else>文件转换完成</span>
                  <div id="cir2" v-if="downloadPercentage < 100">
                    <i-circle :percent="downloadPercentage" :stroke-color="color" :size="40" :stroke-width=3></i-circle>
                  </div>
                </div>
              </Step>
              <Step title="完成" content="可点击下载"></Step>
            </Steps>
          </div>
          <div class="modal-footer" style="padding: 15px 15px;background:white;border-radius: 0 0 4px 4px;">
            <Alert show-icon style="height: 34px;display: inline-block;float: left;margin: 0px;">
              <Icon type="md-bulb" slot="icon"></Icon>
              登录状态下，下载进度将被保留在下载列表中
            </Alert>
            <Button @click="goToHistory" style="margin-right: 10px;width: auto">前往下载列表中查看</Button>
            <Button
                :disabled="downloadCurrentStep!=3"
                @click="okDownload"
                type="primary"
                :loading="downloadCurrentStep!=3"
                style="width: 72px;height: 32px;line-height: 32px"
            >
              下载
            </Button>
          </div>
        </div>
      </div>
    </div>

    <!--  全局账号模态框  第一步 -->
    <div class="modal fade" id="model_first" tabindex="-1" role="dialog" aria-labelledby="dataDownloadModal"
         aria-hidden="true" data-keyboard="false" data-backdrop="static" style="background: transparent">
      <div class="modal-dialog" style="background: white;height: 220px;width: 450px;border-radius: 10px">
        <div>
          <div style="text-align: center; margin: 8px">
            <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                    style="font-size:23px;outline:none;color:rgb(71, 115, 187);">
              &times;
            </button>
          </div>
          <div style="text-align: center;font-size: 15px;color: #626262;padding-top: 40px;font-family: 黑体">
            尊敬的用户您好，您当前使用的账号为公共试用账号
          </div>
          <div style="text-align: center;font-size: 15px;color: #626262;margin-top: 5px;">
            建议您完善个人信息体验更加完整的服务
          </div>
          <div style="text-align: center;margin-top: 20px">
            <el-button style="width: 40%;height: 39px;font-size: 15px;text-align: center" type="primary"
                       @click="information_first">完善信息
            </el-button>
          </div>
          <div style="text-align: center;margin-top: 10px">
            <el-button type="text" style="color: #a2a2a2" @click="loginByFirst">已完善信息？前往登录</el-button>
          </div>
        </div>
      </div>
    </div>

    <!--  全局账号模态框  第二步 -->
    <div class="modal fade" id="model_second" tabindex="-1" role="dialog" aria-labelledby="dataDownloadModal"
         aria-hidden="true" data-keyboard="false" data-backdrop="static" style="background: transparent">
      <div class="modal-dialog"
           style="background: linear-gradient(to bottom,#f0f8fb,#fdfeff,#FFFFFF);height: 410px;width: 480px;border-radius: 10px">
        <div>
          <div style="text-align: center; margin: 8px">
            <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                    style="font-size:23px;outline:none;color:rgb(71, 115, 187);">
              &times;
            </button>
          </div>
          <div style="text-align: center;font-size: 22px;color: black;padding-top: 40px;">
            完善个人信息
          </div>
          <div style="text-align: center;font-size: 14px;color: gray;margin-top: 5px;">
            - 体验爱文本完整服务 -
          </div>

          <div style="padding-left: 50px;padding-right: 50px;padding-top: 20px">

            <el-form ref="form_second" :model="form_second">
              <label>手机号码</label>
              <el-form-item>
                <el-input v-model="form_second.phone" placeholder="请输入手机号码" @input="valPhone"></el-input>
                <div class="tab_s" id="phoneTip"
                     style="display:none;float:left;height:15px;padding:1px;color: red"> *&nbsp;请输入正确的手机号
                </div>
              </el-form-item>

              <label>验证码</label>
              <el-form-item>
                <el-row>
                  <el-col :span="18">
                    <el-input v-model="form_second.code" placeholder="请输入验证码" style="padding-right: 12px"></el-input>
                  </el-col>
                  <el-col :span="6">

                    <Button @click="sendPhone" id='button1' style="padding: 0;text-align: center;"
                            v-if="time!==0 && time!==60">{{ time }}
                    </Button>
                    <Button @click="sendPhone" id='button1' style="padding: 0;text-align: center; height: 40px" v-else>
                      发送验证码
                    </Button>
                  </el-col>
                </el-row>
                <div class="tab_s" id="codeTip"
                     style="display:none;float:left;height:15px;padding:1px;color: red"> *&nbsp;验证码错误
                </div>
              </el-form-item>


              <el-form-item style="text-align: center;margin-top: 40px">
                <el-button type="primary" @click="second_next" style="width: 100%;height: 45px">下一步</el-button>
              </el-form-item>
            </el-form>


            <!--            <label>手机号码</label>-->
            <!--            <div style="margin-top: 10px;margin-bottom: 20px">-->
            <!--              <el-input v-model="second_phone" placeholder="请输入手机号码"></el-input>-->
            <!--            </div>-->
            <!--            <label>验证码</label>-->
            <!--            <div style="margin-top: 10px">-->
            <!--              <el-row>-->
            <!--                <el-col :span="18">-->
            <!--                  <el-input v-model="second_code" placeholder="请输入验证码" style="padding-right: 12px"></el-input>-->
            <!--                </el-col>-->
            <!--                <el-col :span="6">-->

            <!--                  <Button @click="sendPhone" id='button1' style="padding: 0;text-align: center;"-->
            <!--                          v-if="time!==0 && time!==60">{{ time }}-->
            <!--                  </Button>-->
            <!--                  <Button @click="sendPhone" id='button1' style="padding: 0;text-align: center; height: 40px" v-else>发送验证码-->
            <!--                  </Button>-->
            <!--                </el-col>-->
            <!--              </el-row>-->
            <!--            </div>-->

          </div>

        </div>
      </div>
    </div>

    <!--  全局账号模态框  第三步 -->
    <div class="modal fade" id="model_third" tabindex="-1" role="dialog" aria-labelledby="dataDownloadModal"
         aria-hidden="true" data-keyboard="false" data-backdrop="static" style="background: transparent">
      <div class="modal-dialog"
           style="background: linear-gradient(to bottom,#f0f8fb,#fdfeff,#FFFFFF);height: 610px;width: 480px;border-radius: 10px">
        <div>
          <div style="text-align: center; margin: 8px">
            <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                    style="font-size:23px;outline:none;color:rgb(71, 115, 187);">
              &times;
            </button>
          </div>
          <div style="text-align: center;font-size: 22px;color: black;padding-top: 40px;">
            完善个人信息
          </div>
          <div style="text-align: center;font-size: 14px;color: gray;margin-top: 5px;">
            - 体验爱文本完整服务 -
          </div>

          <div style="padding-left: 50px;padding-right: 50px;padding-top: 20px">

            <el-form ref="form_second" :model="form_third">
              <label>密码</label>
              <el-form-item>
                <el-input placeholder="请设置密码" v-model="form_third.password" show-password
                          @input="passwordTest"></el-input>
                <div class="tab_s" id="passwordTip"
                     style="display:none;float:left;height:10px;color: red"> *&nbsp;密码不能为空
                </div>
              </el-form-item>

              <label>邮箱</label>
              <el-form-item>
                <el-input v-model="form_third.email" placeholder="请输入邮箱" @input="emailTest"></el-input>
                <div class="tab_s" id="emailTip"
                     style="display:none;float:left;height:10px;color: red"> *&nbsp;邮箱格式错误
                </div>
              </el-form-item>

              <label>学校全称</label>
              <el-form-item>
                <el-select v-model="form_third.school" filterable placeholder="请选择" style="width: 100%">
                  <el-option
                      v-for="item in schoolNameList"
                      :key="item.id"
                      :label="item.adress"
                      :value="item.adress">
                  </el-option>
                </el-select>
                <div class="tab_s" id="schoolTip"
                     style="display:none;float:left;height:10px;color: red"> *&nbsp;学校全称不能为空
                </div>
              </el-form-item>

              <label>身份</label>
              <el-form-item>
                <el-col :span="6">
                  <el-radio v-model="form_third.identity" label="1" border>教师</el-radio>
                </el-col>
                <el-col :span="9">
                  <el-radio v-model="form_third.identity" label="2" border>在读博士生</el-radio>
                </el-col>
                <el-col :span="9">
                  <el-radio v-model="form_third.identity" label="3" border>其他研究人员</el-radio>
                </el-col>
              </el-form-item>


              <el-form-item style="text-align: center;margin-top: 40px">
                <el-col :span="12" style="padding-right: 15px">
                  <el-button style="width: 100%;height: 40px" @click="lastStep">上一步</el-button>
                </el-col>
                <el-col :span="12" style="padding-left: 15px">
                  <el-button type="primary" style="width: 100%;height: 40px" @click="finish">完成</el-button>
                </el-col>
              </el-form-item>
            </el-form>


            <!--            <label>密码</label>-->
            <!--            <div style="margin-top: 10px;margin-bottom: 20px">-->
            <!--              <el-input placeholder="请设置密码" v-model="input" show-password></el-input>-->
            <!--            </div>-->
            <!--            <label>邮箱</label>-->
            <!--            <div style="margin-top: 10px;margin-bottom: 20px">-->
            <!--              <el-input v-model="input" placeholder="请输入邮箱"></el-input>-->
            <!--            </div>-->
            <!--            <label>学校全称</label>-->
            <!--            <div style="margin-top: 10px;margin-bottom: 20px">-->
            <!--              <el-input v-model="input" placeholder="请输入学校"></el-input>-->
            <!--            </div>-->

            <!--            <label>身份</label>-->
            <!--            <div style="margin-top: 10px;margin-bottom: 45px">-->
            <!--              <el-col :span="6">-->
            <!--                <el-radio v-model="radio1" label="1" border>教师</el-radio>-->
            <!--              </el-col>-->
            <!--              <el-col :span="9">-->
            <!--                <el-radio v-model="radio1" label="2" border>在读博士生</el-radio>-->
            <!--              </el-col>-->
            <!--              <el-col :span="9">-->
            <!--                <el-radio v-model="radio1" label="3" border>其他研究人员</el-radio>-->
            <!--              </el-col>-->
            <!--            </div>-->

            <!--            <div style="text-align: center;padding-top: 40px">-->
            <!--              <el-col :span="12" style="padding-right: 15px">-->
            <!--                <el-button style="width: 100%;height: 40px" @>上一步</el-button>-->
            <!--              </el-col>-->
            <!--              <el-col :span="12" style="padding-left: 15px">-->
            <!--                <el-button type="primary" style="width: 100%;height: 40px">完成</el-button>-->
            <!--              </el-col>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!--  全局账号模态框  第四步 -->
    <div class="modal fade" id="model_four" tabindex="-1" role="dialog" aria-labelledby="dataDownloadModal"
         aria-hidden="true" data-keyboard="false" data-backdrop="static" style="background: transparent">
      <div class="modal-dialog"
           style="background: linear-gradient(to bottom,#f0f8fb,#fdfeff,#FFFFFF);height: 310px;width: 480px;border-radius: 10px">
        <div>
          <div style="text-align: center; margin: 8px">
            <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                    style="font-size:23px;outline:none;color:rgb(71, 115, 187);">
              &times;
            </button>
          </div>
          <div style="text-align: center;font-size: 22px;color: black;padding-top: 60px;">
            <i style="color: #2d8cf0;font-size: 35px" class="el-icon-success"></i>
          </div>
          <div
              style="text-align: center;font-size: 18px;color: #2d8cf0;margin-top: 10px;font-weight: bold;font-family: 黑体">
            信息完善成功
          </div>
          <div style="text-align: center;font-size: 14px;color: gray;margin-top: 10px">
            已为您开通新账号：用户名为手机号
          </div>
          <div style="text-align: center;font-size: 14px;color: gray;margin-top: 2px;">
            期限为一个月
          </div>

          <div style="padding-left: 50px;padding-right: 50px;padding-top: 30px">
            <div style="text-align: center;">
              <el-button type="primary" style="width: 100%;height: 40px" @click="loginByNewAccount">前往登录新账号
                <i class="el-icon-right"></i>
              </el-button>
            </div>

          </div>
        </div>
      </div>
    </div>


    <!-- <Modal
      v-model="modalDownload"
      title="下载进度"
      @on-ok="okDownload"
      :closable="false"
      :mask-closable="false"
      width="40"
      @on-cancel="cancel"
    >
      <Steps :current="downloadCurrentStep">
        <Step title="已提交" content="下载任务已提交"></Step>
        <Step title="压缩中" content="文件正在压缩"></Step>
        <Step title="完成" content="压缩完成"></Step>
      </Steps>
      <div slot="footer">
        <Button type="text" @click="cancel">取消</Button>
        <Button
          :disabled="downloadCurrentStep!=2"
          @click="okDownload"
          type="primary"
          :loading="downloadCurrentStep!=2"
        >下载</Button>
      </div>
    </Modal> -->

  </div>
</template>

<script>
import axios from "../api/axios";
import {mapState, mapMutations, mapGetters, mapActions} from "vuex";
import DatePicker from './DatePicker.vue'
import globalFunction from "../api/globalFunction.js";
// import Velocity from "velocity-animate";
export default {
  data() {
    return {
      schoolNameList: [],
      form_second: {
        phone: '',
        code: ''
      },
      form_third: {
        password: '',
        email: '',
        school: '',
        identity: '1',
      },
      time: 60,


      formLabelWidth: '120px',
      minDate: new Date(631123200000),
      maxDate: new Date(),
      showstockcodediv: false,
      stock_loading: true,
      headerList: [],
      dataType: "",
      simpleData: [],
      keyword: "",
      selectYear: [],
      data1: [],
      timeSelect: "NoLimit",
      dictSelect: "ZiDingYiDict",
      selectedYears: [],
      stockCodeSelect: "SelectAll",
      stockCode_selected_temporaryArray: [],
      stockCode_nameArray: [],
      stockCode_name_selected_Array: [],
      stockCode_temporaryArray: [],
      stockCodeUnSelect_serach: "",
      stockCodeSelect_serach: "",
      uploadStockCodeArray: [],
      selectedField: [],
      unselectedField: [],
      unSelect_serach: "",
      select_serach: "",
      previewData: [],
      previewHeaderList: [],
      previewLoading: true,
      downloadCurrentStep: 1,
      downloadTasks: [],
      modalDownload: false,
      errorInfoArray: "",
      params: {},
      downloadTable: '基本信息',
      fileName: '',
      downloadPercentage: 0,
      zipPercentage: 0,
      AuthLevel: 1,
      hasDate: false,
      showAuth: true,
      dataload: false,
      keyListInfoArray: "",
      keyModel: false,
    };
  },
  components: {
    "datepicker": DatePicker
  },
  filters: {
    fileTypeFilter: value => {
      return [
        {key: "Xlsx", value: "Excel2007格式（*.xlsx）"},
        {key: "Txt", value: "TXT文本格式（*.txt）"},
        {key: "Txt_mat", value: "Txt创建Matlab数据集 (*.mat)"},
        {key: "Txt_dta", value: "Txt创建Stata数据集 (*.dta)"},
        {key: "Txt_r", value: "Txt创建R数据集 (*.R) "},
        {key: "Csv", value: "逗号分隔文本 (*.csv) "},
        {key: "Csv_mat", value: "Csv创建Matlab数据集 (*.mat)"},
        {key: "Csv_dta", value: "Csv创建Stata数据集 (*.dta)"},
        {key: "Xml", value: "Xml文件 (*.xml)"},
        {key: "Xls", value: "Excel2003格式（*.xls）"},
        {key: "Xls_mat", value: "Excel格式创建Matlab数据（*.xls）"},
        {key: "Html", value: "HTML格式（*.html）"},
        {key: "Sav", value: "SPSS格式（*.sav）"},
        {key: "Dbf", value: "DBase dbf格式（*.dbf）"}
      ].filter(s => s.key == value)[0].value;
    }
  },
  updated() {
    $('[data-toggle="popover"]').popover({
      template:
          '<div class="popover" style="font-family:微软雅黑;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content" style="max-height:200px;overflow:auto;"></div></div>'
    });
    $("#dataPreviewModal .modal-content").click(e => {
      if (!$(e.target).hasClass("colDetail")) {
        $(".colDetail").popover("hide");
      }
    });
  },
  watch: {
    '$route.path'(newVal, oldVal) {
      setTimeout(() => {
        this.selectedField = this.unselectedField
        this.unselectedField = [];
      }, 500)
    },
    stockCodeUnSelect_serach: function (val, oldVal) {
      if (val == "") {
        this.stockCode_temporaryArray = [];
      } else {
        var temporaryArray = new Array();
        temporaryArray = this.stockCode_nameArray.filter(
            s => s.code.indexOf(val) >= 0 || s.name.indexOf(val) >= 0
        );
        if (temporaryArray.length > 0) {
          this.stockCode_temporaryArray = temporaryArray;
          // this.stockCode_nameArray = this.stockCode_nameArray.filter(s => s.code.indexOf(val) < 0 && s.name.indexOf(val) < 0);
        } else {
          var notObj = new Object();
          notObj.code = "none";
          notObj.name = "未匹配到相应证券";
          temporaryArray.push(notObj);
          this.stockCode_temporaryArray = temporaryArray;
        }
      }
    },
    stockCodeSelect_serach: function (val, oldVal) {
      if (val == "") {
        this.stockCode_selected_temporaryArray = [];
      } else {
        var temporaryArray = new Array();
        temporaryArray = this.stockCode_name_selected_Array.filter(
            s => s.code.indexOf(val) >= 0 || s.name.indexOf(val) >= 0
        );
        if (temporaryArray.length > 0) {
          this.stockCode_selected_temporaryArray = temporaryArray;
          // this.stockCode_nameArray = this.stockCode_nameArray.filter(s => s.code.indexOf(val) < 0 && s.name.indexOf(val) < 0);
        } else {
          var notObj = new Object();
          notObj.code = "none";
          notObj.name = "未匹配到相应证券";
          temporaryArray.push(notObj);
          this.stockCode_selected_temporaryArray = temporaryArray;
        }
      }
    },
    stockCode_temporaryArray: function (val, oldVal) {
      if (val.length == 0) {
        this.stockCodeUnSelect_serach = "";
      }
    },
    $route(to, from) {
      this.AuthLevel = 1
      //进入数据库时添加年份范围
      this.selectYear = []
      this.dataType = this.$route.params.name;
      this.selectedField = []
      this.previewHeaderList = []
      this.headerList = []
      // this.unselectedField = this.currentTableInfo.fields.map(function(s){
      //   return {FieldName:s.key,DisplayName:s.title}
      // });
      this.timeSelect = "NoLimit"
      this.dictSelect = "ZiDingYiDict"
      this.stockCodeSelect = "SelectAll"
      //进入数据库时判断权限
      const url = this.$route.path;
      const urlArr = url.split('/');
      const auths = this.getAuths
      this.stockCode_nameArray = []
      for (let key in auths) {
        if (auths.hasOwnProperty(key)) {
          const item = auths[key];
          if (item.database === urlArr[urlArr.length - 2] || item.database === decodeURIComponent(urlArr[urlArr.length - 2])) {
            //未过期才授权
            const nowDate = new Date().getTime();
            const authDate = new Date(item.endDate).getTime()
            if (authDate > nowDate) {
              this.AuthLevel = item.level
            }
          }
        }
      }
      let codeurl = "/stockIdTable.json"
      axios.get(codeurl).then(response => {
        let dataArray = response.data;
        for (var i = 0; i < dataArray.length; i++) {
          var oneDataObj = dataArray[i];
          this.stockCode_nameArray.push(oneDataObj);
        }
      });
    },
    unSelect_serach: function (val, oldVal) {
      if (val === "") {
        if (this.$route.params.viewname === "CFND_HighTrail") {
          let tempIndex = []
          this.unselectedField = this.currentSystem["tableInfo"][this.$route.params.name].fields ? this.currentSystem["tableInfo"][this.$route.params.name].fields.map((items, index) => {
            this.selectedField.forEach((subItems) => {
              if (subItems.DisplayName === items.ExtraHeaders[0]) {
                tempIndex.push(index);
              }
            });
            return {FieldName: items.FieldName, DisplayName: items.ExtraHeaders[0]}
          }) : this.currentSystem["tableInfo"][this.$route.params.name].Fields.map((items, index) => {
            this.selectedField.forEach((subItems) => {
              if (subItems.DisplayName === items.ExtraHeaders[0]) {
                tempIndex.push(index);
              }
            });
            return {FieldName: items.FieldName, DisplayName: items.ExtraHeaders[0]}
          });
          if (tempIndex) {
            let k = 0;
            for (let i in tempIndex) {
              this.unselectedField.splice(tempIndex[i] - k, 1);
              k++;
            }
          }
        } else {
          let tempIndex = []
          this.unselectedField = this.currentSystem["tableInfo"][this.currentSystem.prefixName + "-" + this.$route.params.name].fields ? this.currentSystem["tableInfo"][this.currentSystem.prefixName + "-" + this.$route.params.name].fields.map((s, index) => {
            this.selectedField.forEach((subItems) => {
              if (subItems.DisplayName === items.ExtraHeaders[0]) {
                tempIndex.push(index);
              }
            });
            return {FieldName: s.key, DisplayName: s.title}
          }) : this.currentSystem["tableInfo"][this.currentSystem.prefixName + "-" + this.$route.params.name].Fields.map((s, index) => {
            this.selectedField.forEach((subItems) => {
              if (subItems.DisplayName === items.ExtraHeaders[0]) {
                tempIndex.push(index);
              }
            });
            return {FieldName: s.key, DisplayName: s.title}
          });
          if (tempIndex) {
            let k = 0;
            for (let i in tempIndex) {
              this.unselectedField.splice(tempIndex[i] - k, 1);
              k++;
            }
          }
        }
      } else {
        var temporaryArray = this.unselectedField;
        temporaryArray = temporaryArray.filter(
            filed => filed.DisplayName.indexOf(val) >= 0
        );
        if (temporaryArray.length > 0) {
          this.unselectedField = temporaryArray;
        } else {
          var notObj = {};
          notObj.Description = "未匹配到相应字段";
          notObj.DisplayName = "未匹配到相应字段";
          notObj.FieldName = "notResult";
          temporaryArray.push(notObj);
          this.unselectedField = temporaryArray;
        }
      }
    },
    select_serach: function (val, oldVal) {
      let temporaryArray;
      if (val === "") {
        if (this.$route.params.viewname === "CFND_HighTrail") {
          let tempIndex = []
          this.selectedField = this.currentSystem["tableInfo"][this.$route.params.name].fields ? this.currentSystem["tableInfo"][this.$route.params.name].fields.map((items, index) => {
            this.unselectedField.forEach((subItems) => {
              if (subItems.DisplayName === items.ExtraHeaders[0]) {
                tempIndex.push(index);
              }
            });
            return {FieldName: items.FieldName, DisplayName: items.ExtraHeaders[0]}
          }) : this.currentSystem["tableInfo"][this.$route.params.name].Fields.map((items, index) => {
            this.unselectedField.forEach((subItems) => {
              if (subItems.DisplayName === items.ExtraHeaders[0]) {
                tempIndex.push(index);
              }
            });
            return {FieldName: items.FieldName, DisplayName: items.ExtraHeaders[0]}
          });
          if (tempIndex) {
            let k = 0;
            for (let i in tempIndex) {
              this.selectedField.splice(tempIndex[i] - k, 1);
              k++;
            }
          }
        } else {
          let tempIndex = []
          this.selectedField = this.currentSystem["tableInfo"][this.currentSystem.prefixName + "-" + this.$route.params.name].fields ? this.currentSystem["tableInfo"][this.currentSystem.prefixName + "-" + this.$route.params.name].fields.map((s, index) => {
            this.unselectedField.forEach((subItems) => {
              if (subItems.DisplayName === items.ExtraHeaders[0]) {
                tempIndex.push(index);
              }
            });
            return {FieldName: s.key, DisplayName: s.title}
          }) : this.currentSystem["tableInfo"][this.currentSystem.prefixName + "-" + this.$route.params.name].Fields.map((s, index) => {
            this.unselectedField.forEach((subItems) => {
              if (subItems.DisplayName === items.ExtraHeaders[0]) {
                tempIndex.push(index);
              }
            });
            return {FieldName: s.key, DisplayName: s.title}
          });
          if (tempIndex) {
            let k = 0;
            for (let i in tempIndex) {
              this.selectedField.splice(tempIndex[i] - k, 1);
              k++;
            }
          }
        }
      } else {
        temporaryArray = this.selectedField;
        temporaryArray = temporaryArray.filter(
            filed => filed.DisplayName.indexOf(val) >= 0
        );
        if (temporaryArray.length > 0) {
          this.selectedField = temporaryArray;
        } else {
          var notObj = {};
          notObj.Description = "未匹配到相应字段";
          notObj.DisplayName = "未匹配到相应字段";
          notObj.FieldName = "notResult";
          temporaryArray.push(notObj);
          this.selectedField = temporaryArray;
        }
      }
    },
    unselectedField: function (val, oldVal) {
      if (val.length === 0) {
        this.unSelect_serach = "";
      }
    },
    selectedField: function (val, oldVal) {
      if (val.length == 0) {
        this.select_serach = "";
      }
    },
    stockCodeSelect: function (val, oldVal) {
      if (val == "Other") {
        this.stock_loading = true;
        this.$nextTick(() => {
          setTimeout(() => {
            this.showstockcodediv = true;
            this.$nextTick(() => {
              this.stock_loading = false;
            });
          }, 300);
        });
        $(".stockCodeInput_inputAndButton_div")
            .stop()
            .slideUp(300);
        $(".stockCodeSelect_div input").val("");
      } else if (val == "Upload") {
        this.showstockcodediv = false;
        $(".stockCodeSelect_inputAndButton_div")
            .stop()
            .slideUp(300);
        $(".stockCodeInput_inputAndButton_div")
            .stop()
            .slideDown(300);
      } else {
        this.showstockcodediv = false;
        $(".stockCodeInput_inputAndButton_div")
            .stop()
            .slideUp(300);
        $(".stockCodeSelect_inputAndButton_div")
            .stop()
            .slideUp(300);
      }
    },
    stockCode_selected_temporaryArray: function (val, oldVal) {
      if (val.length == 0) {
        this.stockCodeSelect_serach = "";
      }
    }
  },
  computed: {
    ...mapGetters(['getAuths']),
    ...mapState(['userInfo']),
    showAuthModel() {
      if (this.showAuth === false) {
        return false;
      }
      if ($.cookie("remindAuth") === "false") {
        return false
      } else {
        return true
      }
    },
    color() {
      let color = '#2d8cf0';
      if (this.downloadPercentage === 100) {
        color = '#5cb85c';
      }
      return color;
    },
    getDownloadTable() {
      return this.currentTableInfo.name
    },
    stockCodeComputed: function () {
      if (this.stockCodeSelect == "SelectAll") {
        return "全部代码";
      } else {
        if (this.params && this.params["code"] && this.params["code"].length > 0) {
          return this.params["code"].join(",");
        } else {
          return ""
        }
      }
    },
    sortStockCodeArray: function () {
      if (this.stockCode_temporaryArray.length > 0) {
        return this.stockCode_temporaryArray.sort(function (data1, data2) {
          var data1CodeInt = parseInt(data1.code);
          var data2CodeInt = parseInt(data2.code);
          return data1CodeInt - data2CodeInt;
        });
      } else {
        return this.stockCode_nameArray.sort(function (data1, data2) {
          var data1CodeInt = parseInt(data1.code);
          var data2CodeInt = parseInt(data2.code);
          return data1CodeInt - data2CodeInt;
        });
      }
    },
    dataRange: function () {
      if (this.timeSelect === "NoLimit") {
        return "时间不限";
      } else if (this.timeSelect === "ByYear") {
        return this.selectYear
      } else {
        var startDateStr = this.params.startDate;
        var endDateStr = this.params.endDate;
        if (startDateStr && endDateStr) {
          var startDateArray = startDateStr.split("-");
          var endDateArray = endDateStr.split("-");
          var start_month = startDateArray[1];
          var start_day = startDateArray[2];
          var end_month = endDateArray[1];
          var end_day = endDateArray[2];
          if (parseInt(start_month) < 10) {
            start_month = start_month;
          }
          if (parseInt(start_day) < 10) {
            start_day = start_day;
          }
          if (parseInt(end_month) < 10) {
            end_month = end_month;
          }
          if (parseInt(end_day) < 10) {
            end_day = end_day;
          }
          return (
              startDateArray[0] +
              "年" +
              start_month +
              "月" +
              start_day +
              "日" +
              " 至 " +
              endDateArray[0] +
              "年" +
              end_month +
              "月" +
              end_day +
              "日"
          );
        }
      }
    },
    ...mapState(["SystemList"]),
    currentSystem() {
      if (this.SystemList[this.$route.params.viewname]) {
        return this.SystemList[this.$route.params.viewname];
      } else {
        return {};
      }
    },
    currentTableInfo() {
      if (this.currentSystem && this.currentSystem["tableInfo"]) {
        if (this.$route.params.viewname === "CFND_HighTrail") {
          this.selectedField = [];
          // 后端数据字段不一致判断 fields Fields
          if (this.currentSystem["tableInfo"][this.$route.params.name].fields) {
            return this.unselectedField = this.currentSystem["tableInfo"][this.$route.params.name].fields.map((items) => {
              return {FieldName: items.FieldName, DisplayName: items.ExtraHeaders[0]}
            });
          } else {
            return this.unselectedField = this.currentSystem["tableInfo"][this.$route.params.name].Fields.map((items) => {
              return {FieldName: items.FieldName, DisplayName: items.ExtraHeaders[0]}
            })
          }
        } else {
          this.unselectedField = this.currentSystem["tableInfo"][this.currentSystem.prefixName + "-" + this.$route.params.name].fields.map(function (s) {
            return {FieldName: s.key, DisplayName: s.title}
          });
          let tempTable = this.currentSystem["tableInfo"][this.currentSystem.prefixName + "-" + this.$route.params.name]
          if (this.$route.params.name === "qinggan") {
            let tempFields = [];
            if (this.dictSelect == "LMDict") {
              tempFields = tempTable.fields.filter(s => s.key != 'Ntusd_posword'
                  && s.key != 'Ntusd_Negword' && s.key != 'AItext_posword' && s.key != 'AItext_Negword'
                  && s.key != 'Ntusd_Tone1' && s.key != 'Ntusd_Tone2' && s.key != 'AItexts_Tone1' && s.key != 'AItexts_Tone2')
            } else if (this.dictSelect == "TaiDaDict") {
              tempFields = tempTable.fields.filter(s => s.key != 'LM_posword'
                  && s.key != 'LM_Negword' && s.key != 'AItext_posword' && s.key != 'AItext_Negword'
                  && s.key != 'LM_Tone1' && s.key != 'LM_Tone2' && s.key != 'AItexts_Tone1' && s.key != 'AItexts_Tone2')
            } else {
              tempFields = tempTable.fields.filter(s => s.key != 'LM_posword'
                  && s.key != 'LM_Negword' && s.key != 'Ntusd_posword' && s.key != 'Ntusd_Negword'
                  && s.key != 'Ntusd_Tone1' && s.key != 'Ntusd_Tone2' && s.key != 'LM_Tone1' && s.key != 'LM_Tone2')
            }
            this.unselectedField = tempFields.map(function (s) {
              return {FieldName: s.key, DisplayName: s.title}
            });
            this.selectedField = [];
          } else {
            this.unselectedField = tempTable.fields.map(function (s) {
              return {FieldName: s.key, DisplayName: s.title}
            });
            this.selectedField = [];
          }
          return tempTable;
        }
      } else {
        return {};
      }
    },
    yearList() {
      let list = []
      let params = this.$route.params;
      let startYear = this.currentTableInfo.startyear
      let nowYear = new Date().getFullYear();
      axios.get("/api/getYearList?mokuai=" + params.viewname + "&type=" + params.name).then((res) => {
        if (res.data.data.length > 0) {
          let data = res.data.data.sort();
          data.forEach((item) => {
            list.push({
              value: item.toString(),
              label: item.toString()
            })
          })
        } else {
          for (let i = startYear; i <= nowYear; i++) {
            list.push({
              value: i,
              label: i
            })
          }
        }
      });
      return list


    },
    currentTableInfoFields() {
      if (this.currentTableInfo) {
        let tempTable = this.currentTableInfo
        if (this.$route.params.name === "qinggan") {
          let tempFields = []
          if (this.dictSelect === "LMDict") {
            tempFields = tempTable.fields.filter(s => s.key !== 'Ntusd_posword'
                && s.key !== 'Ntusd_Negword' && s.key !== 'AItext_posword' && s.key !== 'AItext_Negword'
                && s.key !== 'Ntusd_Tone1' && s.key !== 'Ntusd_Tone2' && s.key !== 'AItexts_Tone1' && s.key !== 'AItexts_Tone2')
          } else if (this.dictSelect === "TaiDaDict") {
            tempFields = tempTable.fields.filter(s => s.key !== 'LM_posword'
                && s.key !== 'LM_Negword' && s.key !== 'AItext_posword' && s.key !== 'AItext_Negword'
                && s.key !== 'LM_Tone1' && s.key !== 'LM_Tone2' && s.key !== 'AItexts_Tone1' && s.key !== 'AItexts_Tone2')
          } else {
            tempFields = tempTable.fields.filter(s => s.key !== 'LM_posword'
                && s.key !== 'LM_Negword' && s.key !== 'Ntusd_posword' && s.key !== 'Ntusd_Negword'
                && s.key !== 'Ntusd_Tone1' && s.key !== 'Ntusd_Tone2' && s.key !== 'LM_Tone1' && s.key !== 'LM_Tone2')
          }
          return tempFields
        } else {
          return tempTable.fields
        }
      } else {
        return []
      }

    },
    headerList1() {
      let map = this.headerList.map(
          s => this.currentTableInfo["fields"].filter(x => x.key == s)[0].title
      );
      return map
    },
    uploadFile: function () {
      var fileName = $("#uploadfile").val();
      if (
          fileName.indexOf(".txt") > 0 ||
          fileName.indexOf(".TXT") > 0 ||
          fileName.indexOf(".xls") > 0 ||
          fileName.indexOf(".XLS") > 0 ||
          fileName.indexOf(".xlsx") > 0 ||
          fileName.indexOf(".XLSX") > 0
      ) {
        $("#uploadFile_form").submit();
      } else if (fileName != "") {
        this.errorInfoArray = "您上传的文件格式有误！";
        $("#errorInfoModal").modal();
        // alert('您上传的文件格式有误！');
      }
      $("#uploadfile").val("");
    },
    // 数据预览表头
    previewHeaderList1() {
      if (this.$route.params.viewname === "CFND_HighTrail") {
        let temp = [];
        this.currentSystem["tableInfo"][this.$route.params.name].fields ? this.currentSystem["tableInfo"][this.$route.params.name].fields.forEach((items) => {
          temp.push(items.DisplayName);
        }) : this.currentSystem["tableInfo"][this.$route.params.name].Fields.forEach((items) => {
          temp.push(items.DisplayName);
        });
        return temp;
      } else {
        let map = this.previewHeaderList.map(s => this.currentTableInfo["fields"].filter(x => x.key === s)[0].title);
        return map
      }

    },
    sortSelectedStockCodeArray: function () {
      if (this.stockCode_selected_temporaryArray.length > 0) {
        return this.stockCode_selected_temporaryArray.sort(function (
            data1,
            data2
        ) {
          var data1CodeInt = parseInt(data1.code);
          var data2CodeInt = parseInt(data2.code);
          return data1CodeInt - data2CodeInt;
        });
      } else {
        return this.stockCode_name_selected_Array.sort(function (data1, data2) {
          var data1CodeInt = parseInt(data1.code);
          var data2CodeInt = parseInt(data2.code);
          return data1CodeInt - data2CodeInt;
        });
      }
    },

  },
  created() {
    //进入数据库时添加年份范围
    this.selectYear = []

    //进入数据库时判断权限
    this.AuthLevel = 1
    const url = this.$route.path;
    const urlArr = url.split('/');
    const auths = this.getAuths


    for (let key in auths) {

      // alert(key)
      if (auths.hasOwnProperty(key)) {
        const item = auths[key];

        if (item.database === urlArr[urlArr.length - 2] || item.database === decodeURIComponent(urlArr[urlArr.length - 2])) {
          //未过期才授权
          const nowDate = new Date().getTime();
          const authDate = new Date(item.endDate).getTime()
          if (authDate > nowDate) {
            this.AuthLevel = item.level
          }
        }
      }
    }
    let codeurl = "/stockIdTable.json"
    axios.get(codeurl).then(response => {
      let dataArray = response.data;
      for (var i = 0; i < dataArray.length; i++) {
        var oneDataObj = dataArray[i];
        this.stockCode_nameArray.push(oneDataObj);
      }
    });
  },
  async mounted() {
    /*if (this.$route.query.key) {
      this.keyword = this.$route.query.key
      this.keyWordQuery();
    }*/
    this.dataType = this.$route.params.name;
    // this.unselectedField = this.currentTableInfo.fields.map(function(s){
    //   return {FieldName:s.key,DisplayName:s.title}
    // });
    this.selectedField = []
    var query = this.$route.query
    if (query && query.keyword) {
      this.selectAllField();
      this.keyword = query.keyword;
      if (this.$store.state.isDownLoadM) {
        this.DownLoadM();
      }
    } else {
      this.selectAllField();
    }
    axios.get("/api/register/getSchoolDetailList").then((res) => {
      if (res.status === 200) {
        this.schoolNameList = res.data
      }
    }).catch((e) => {
      console.warn(e)
    })
  },
  methods: {
    ...mapMutations(["PUSH_TASKMD5lIST", "SET_USER_SIGNOUT", "SET_ISDOWNLOAD"]),
    ...mapActions(['signOut']),

    removeAllYear() {
      this.selectYear = []
    },
    // 选择年份的最大标签数
    maxTagPlaceholder(num) {
      return 'more ' + num;
    },
    goToHistory() {
      clearInterval(this.timer);
      $("#dataDownloadModal").modal("hide");
      this.$emit('showHistory')
    },
    //切换选项卡
    changeModelCard(value) {
      this.$emit('changeModelCard', value)
    },
    //退出登录并跳转至登录界面
    gotoLogin: async function () {
      $("#roleInfoModal").modal('hide');
      await this.signOut();
      this.SET_USER_SIGNOUT();
      this.$store.state.taskMD5List = []
      window.sessionStorage.removeItem("store")
      this.$router.push('/');
      $.cookie("modalFlag", "", {expires: -1});
    },
    handleBeforeUpload() {
      this.$refs.uploadcode.clearFiles()
    },
    handleUploadSuccess(res, file) {
      this.$Message.success("上传成功。")
      this.uploadStockCodeArray = res.data
    },
    handleUploadErr(err) {
      this.$Message.error("上传失败，系统异常！")
    },
    handleUploadFormat(file) {
      this.$Message.error("上传格式错误！请上传txt或者excel文件。")
    },
    addOneOptionToSelected: function (data) {
      if (data.code != "none") {
        this.stockCode_nameArray = this.stockCode_nameArray.filter(
            s => s.code != data.code
        );
        this.stockCode_temporaryArray = this.stockCode_temporaryArray.filter(
            s => s.code != data.code
        );
        this.stockCode_name_selected_Array.push(data);
      }
    },
    removeOneOption: function (data) {
      if (data.code != "none") {
        this.stockCode_name_selected_Array = this.stockCode_name_selected_Array.filter(
            s => s.code != data.code
        );
        this.stockCode_selected_temporaryArray = this.stockCode_selected_temporaryArray.filter(
            s => s.code != data.code
        );
        this.stockCode_nameArray.push(data);
      }
    },
    hideOtherPopover(e) {
      $(e.currentTarget).addClass("thisPopover");
      var updateObjArray = $(".colDetail");
      for (var i = 0; i < updateObjArray.length; i++) {
        var oneObj = $(updateObjArray[i]);
        if (!oneObj.hasClass("thisPopover")) {
          if (
              oneObj
                  .parent()
                  .find("div:first-child")
                  .hasClass("arrow")
          ) {
            oneObj.click();
          }
        }
      }
      $(e.currentTarget).removeClass("thisPopover");
    },
    AddDownloadTask() {
      $("#downloadSummaryModal").modal("hide");
      let data = this.getParams();
      if (data) {
        this.downloadCurrentStep = 1
        this.downloadTasks = []
        this.zipPercentage = 0;
        this.downloadPercentage = 0;
        axios
            .post("/api/ExportFile", data)
            .then(response => {
              if (response.data.msg === '403') {
                this.$Message.error("没有下载权限!")
              } else {
                if (response.data.status) {
                  //添加进下载记录
                  let flag = false
                  for (let i = 0; i < this.$store.state.taskMD5List.length; i++) {
                    if (this.$store.state.taskMD5List[i].md5 === response.data.data) {
                      flag = true
                    }
                  }
                  if (!flag) {
                    this.PUSH_TASKMD5lIST(response.data.data)
                  }
                  $("#dataDownloadModal").modal();
                  this.getDownloadResult(response.data.data);
                } else {
                  this.$Notice.error({
                    title: "提示",
                    desc: response.data.msg
                  });
                }
              }
            })
            .catch(function (error) {
              console.log(error);
            });
      }
    },
    getDownloadResult(md5) {
      this.downloadCurrentStep = 1;
      this.timer = setInterval(() => {
        axios
            .post("/api/getDownloadResult", {md5})
            .then(response => {
              if (response.data.data.percentage > 0) {
                this.downloadCurrentStep = 2
              }
              if (response.data.data.process === 'finish') {
                this.downloadPercentage = 100;
                this.fileName = response.data.data.condition
                clearInterval(this.timer);
                this.downloadCurrentStep = 3;
              }
              this.downloadPercentage = Number.parseInt(response.data.data.percentage)
              this.downloadTasks = response.data.data
            })
            .catch(function (error) {
              console.log(error);
            });
      }, 3000);
    },
    okDownload() {
      let md5 = this.downloadTasks.taskMD5;
      //修改下载状态为已经下载
      this.SET_ISDOWNLOAD(md5);
      axios
          .post("/api/getDownloadUrl", {md5: md5})
          .then(response => {
            var a = document.createElement("a");
            a.href = response.data.data
            a.click()
            $("#dataDownloadModal").modal("hide");
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    cancel() {
      clearInterval(this.timer);
      // this.modalDownload = false;
      $("#dataDownloadModal").modal("hide");
    },
    //权限验证
    asd() {
      if ($("#noWarningCheck")[0].checked) {
        $.cookie('remindAuth', 'false');
        this.showAuth = false
      }
      $("#downloadSummaryModal").modal();
    },
    //下载按钮点击事件
    DownLoadM: async function () {
      if (this.$store.state.TrialAccount) {
        $("#model_first").modal();
        return;
      }else {
        this.$store.commit("setIsDownLoadM", false);
        //判断是否是词频数据库，词频数据库未购买不提供样本下载
        const url = this.$route.path.split('/')
        if (url[url.length - 1] === 'cipin') {
          if (this.AuthLevel !== 3 && this.AuthLevel !== 2) {
            this.$Message.info('您目前处于试用阶段，词频数据不提供下载哟')
            return
          }
        }
        var params = this.getParams()
        if (params) {
          if (this.AuthLevel === 3) {
            $("#downloadSummaryModal").modal();
          } else {
            if (this.showAuthModel) {
              $("#roleInfoModal").modal();
            } else {
              $("#downloadSummaryModal").modal();
            }
          }
        }
      }
    },
    closePreviewDialog() {
      clearInterval(this.timer);
      // $(".sampleData_table_div").scrollTop(0);
    },
    // 字段排序
    sortFieldByOrigin(arr) {
      let fieldNameList;
      if (this.$route.params.viewname === "CFND_HighTrail") {
        fieldNameList = this.unselectedField;
      } else {
        fieldNameList = this.currentTableInfoFields.map(function (s) {
          return {FieldName: s.key, DisplayName: s.title}
        });
      }
      return arr.sort(function (a, b) {
        return fieldNameList.indexOf(a.FieldName) - fieldNameList.indexOf(b.FieldName);
      });
    },

    //选择字段
    selectThisField(field) {
      if (field.FieldName !== "notResult") {
        this.selectedField.push(field);
        this.unselectedField = this.unselectedField.filter(
            s => s.FieldName !== field.FieldName
        );
        this.sortFieldByOrigin(this.selectedField)
        this.sortFieldByOrigin(this.unselectedField)
      }
    },
    //删除字段
    removeThisField(field) {
      if (field.FieldName !== "notResult") {
        this.unselectedField.push(field);
        this.selectedField = this.selectedField.filter(
            s => s.FieldName !== field.FieldName
        );
        this.sortFieldByOrigin(this.selectedField)
        this.sortFieldByOrigin(this.unselectedField)
      }
    },
    removeAllField() {
      $(".checkedFont_removeAll").css("opacity", "1");
      $(".checkedFont_selectAll").css("opacity", "0");
      if (this.select_serach === "") {
        if (this.$route.params.viewname === "CFND_HighTrail") {
          this.unselectedField = this.currentSystem["tableInfo"][this.$route.params.name].fields.map((items) => {
            return {FieldName: items.FieldName, DisplayName: items.ExtraHeaders[0]}
          });
        } else {
          this.unselectedField = this.currentTableInfoFields.map(function (s) {
            return {FieldName: s.key, DisplayName: s.title}
          });
        }
        this.selectedField = [];
      } else {
        if (
            $(
                ".field-select-selected .field-select-fieldlist li:first-child"
            ).text() !== "未匹配到相应字段"
        ) {
          this.unselectedField = this.unselectedField.concat(
              this.selectedField
          );
          this.selectedField = [];
        }
      }
    },
    getParams(type) {
      let data = {code: [], year: []};
      switch (this.dataType) {
        case "cipin":
          if (!this.keyword) {
            this.errorInfoArray = "您未输入关键词，请输入后再操作！";
            $("#errorInfoModal").modal();
            return false;
          }
          data["keyword"] = this.keyword.split(",");
          // 增加查询词数限制, 限制五个或五个以下
          //if (data["keyword"].length > 5) {
          if (data["keyword"].length > 100) {
            this.errorInfoArray = "您输入的关键字数量超过100个，请将关键词数量控制在100个以下";
            $("#errorInfoModal").modal();
            return false;
          }
          break;
        case "qinggan":
          data["cidian"] = this.dictSelect;
          break;
      }
      if (this.stockCodeSelect == "Other") {
        if (this.stockCode_name_selected_Array.length == 0) {
          this.errorInfoArray = "您未选择证券代码，请选择后再操作！";
          $("#errorInfoModal").modal();
          return false;
        } else {
          data["code"] = this.stockCode_name_selected_Array.map(s => s.code);
        }
      } else if (this.stockCodeSelect == "Upload") {
        if (this.uploadStockCodeArray.length == 0) {
          this.errorInfoArray = "您未上传文件，请上传文件后再操作！";
          $("#errorInfoModal").modal();
          return false;
        } else {
          data["code"] = this.uploadStockCodeArray;
        }
      }

      if (this.timeSelect == "Custom") {
        if ($("#startDate").val() == "" || $("#enddate").val() == "") {
          this.errorInfoArray = "您时间选择有误，请修改后再操作！";
          $("#errorInfoModal").modal();
          return false;
        } else {
          data["startDate"] = $("#startDate").val();
          data["endDate"] = $("#enddate").val();
        }
      } else if (this.timeSelect == "ByYear") {
        if (this.selectYear === '' || this.selectYear == null) {
          this.errorInfoArray = "您时间选择有误，请修改后再操作！";
          $("#errorInfoModal").modal();
          return false;
        } else {
          data["year"] = this.selectYear
        }
      }
      if (type == "keywordquery") {
        data["fields"] = this.currentTableInfoFields.map(function (s) {
          return s.key
        });
      } else if (this.selectedField.length <= 0) {
        this.errorInfoArray = "您未选择任何字段,请选择后再操作！";
        $("#errorInfoModal").modal();
        return false;
      } else {
        data["fields"] = this.selectedField.map(s => s.FieldName);
      }
      data["dataType"] = this.timeSelect;
      data["mokuai"] = this.currentSystem.system;
      data["type"] = this.dataType;
      this.params = data;
      return data;
    },
    uploadFileChange() {
      var fileName = $("#uploadfile").val();
      if (fileName.indexOf(".txt") > 0 ||
          fileName.indexOf(".TXT") > 0 ||
          fileName.indexOf(".xls") > 0 ||
          fileName.indexOf(".XLS") > 0 ||
          fileName.indexOf(".xlsx") > 0 ||
          fileName.indexOf(".XLSX") > 0) {
        $("#uploadFile_form").submit();
      } else if (fileName != "") {
        this.$Message.info("您上传的文件格式有误!")
      }
      $("#uploadfile").val("");
    },
    uploadThisFile() {
      $("#uploadfile").click();
    },
    keyWordDownload() {
      var a = document.createElement("a"); //创建一个<a></a>标签
      a.href = "/data/KeyWordTemplate.zip"; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = "KeyWordTemplate.zip"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = "none"; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
    },
    async keyWordQuery() {
      if (!this.keyword) {
        this.$Message.info("请输入关键词!")
        return
      }
      axios.defaults.timeout = 15000;
      this.dataload = true;
      let response = await this.query("keywordquery").catch(() => {
        this.dataload = false;
      })
      if (response) {
        if (response.status) {
          this.simpleData = response.data.data;
        }
      } else {
        this.simpleData = []
      }

      this.dataload = false;
      if (this.simpleData.length > 0) {
        this.headerList = Object.keys(this.simpleData[0]);
        // 增加一个判断，查询的关键字中是否有不存在的关键字
        let data = this.getParams("keywordquery");
        console.error(data);
        await axios.post("/api/containKey", data)
            .then(res => {
              if (res.data.data != "关键字都存在") {
                this.errorInfoArray = "多个词汇中，存在有未收录词，请单独搜索：" + res.data.data;
                $("#errorInfoModal").modal();
              }
            })
      } else {
        this.headerList = [];
        if (this.userInfo.tel != '') {
          let data = this.getParams("keywordquery");
          if (data) {
            axios.post("/api/userKeyCon", data)
                .then(res => {
                  this.errorInfoArray = "该关键词未收录在网页版中，您可以在增强版客户端中通过自定义文本和关键词的方式进行分析。";
                  $("#errorInfoModal").modal();
                  return;
                  // 已经查询过该数据，直接进入个人中心查看即可
                  if (res.data.data.exist == "已经存在") {
                    this.errorInfoArray = "该关键词已搜索，请到个人中心查询。若不能下载，请等待一个工作日。";
                    $("#errorInfoModal").modal();
                    return;
                  }
                  // 1.正式用户
                  if (res.data.data.state == "正式用户") {
                    this.keyModel = true;
                  }
                  // 2.测试用户
                  else {
                    // 判断剩余词语的数量不可以查询
                    if (res.data.data.limited >= res.data.data.limit) {
                      this.errorInfoArray = "个人试用账号特殊关键词查询已达上限（个人试用仅支持查询五个关键词）";
                      $("#errorInfoModal").modal();
                    }
                    //判断可以查询
                    else {
                      // 查询的词语数量不能超过限定
                      let count = this.keyword.split(",");
                      if (count.length + res.data.data.limited > res.data.data.limit) {
                        let aaa = res.data.data.limit - res.data.data.limited
                        this.errorInfoArray = "关键词查询超过上限，您能查询关键词数量为" + aaa + "个";
                        $("#errorInfoModal").modal();
                      } else {
                        this.keyModel = true;
                      }
                    }
                  }
                })
          }
        } else {
          this.errorInfoArray = "您提供的词汇目前未收录，如需获得该词汇的词频，请申请个人账号登录，我们会在一个工作日内给您发送统计结果。";
          $("#errorInfoModal").modal();
        }
      }
      this.loading = false;
    },
    async keyDefine() {
      //debugger
      let data = this.getParams("keywordquery");
      if (data) {
        return await axios
            .post("/api/keyDefine", data)
            .then(res => {
              if (res.data.msg == "数据库不存在") {
                this.$Message.success("提交关键字成功")
              } else if (res.data.msg == "数据库已存在") {
                this.errorInfoArray = "该关键字已被搜索，请查看个人中心";
                $("#errorInfoModal").modal();
              } else {
                this.errorInfoArray = "关键词提交失败请重试，如果多次失败请联系客服";
                $("#errorInfoModal").modal();
              }
            })
            .catch(() => {
              this.errorInfoArray = "关键词提交失败请重试，如果多次失败请联系客服";
              $("#errorInfoModal").modal();
            })
      }
    },

    async preview() {
      let data = this.getParams();
      if (data) {
        this.previewLoading = true;
        this.previewHeaderList = []
        $("#dataPreviewModal").modal();
        let response = await this.query()
        this.previewData = response.data.data;
        if (this.previewData.length > 0) {
          this.previewHeaderList = Object.keys(this.previewData[0]);
        } else {
          this.previewHeaderList = [];
        }
        if (this.previewData.length > 0) {
          $(".preview_simpledata_table").floatThead({
            scrollContainer: function ($table) {
              return $table.closest(".preview_sampleData_table_div");
            },
            responsiveContainer: function ($table) {
              return $table.closest(".preview_sampleData_table_div");
            }
          });
        } else {
          $(".floatThead-container").empty();
        }
        this.previewLoading = false;
      }
    },
    // 使用 asyns/await 将 axios 异步请求同步化
    async query(type) {
      let data = this.getParams(type);
      if (data) {
        return await axios
            .post("/api/preview", data, { timeout: 60000 })
      }
    },
    showUploadInfo(e) {
      if ($(e.currentTarget).length == 0) {
        return;
      }
      var responseTetx = $(e.currentTarget)[0].contentDocument.body.textContent;
      if (responseTetx) {
        var responseJsonObj = JSON.parse(responseTetx);
        if (responseJsonObj.status == true) {
          this.keyword = responseJsonObj.data.join();
          // var resTempArray = new Array();
          // var resTempObj = new Object();
          // for (var i = 0; i < responseJsonObj.data.length; i++) {
          //   var oneObj = responseJsonObj.data[i];
          // }
          // this.uploadStockCodeArray = resTempArray;
          // $(".stockCodeSelect_div input").val(resTempArray.join());
          // $(".stockCodeSelect_div input").attr("title", resTempArray.join());
        } else {
          this.errorInfoArray = responseJsonObj.msg;
          $("#errorInfoModal").modal();
          // if (responseJsonObj.msg = "文件太大") {
          //   this.errorInfoArray = "文件上传失败！请上传小于1M的文件！";
          //   $("#errorInfoModal").modal();
          // }
          // else {
          //   this.errorInfoArray = "文件上传失败！请确认文件内容是否正确！";
          //   $("#errorInfoModal").modal();
          // }
        }
      }
    },
    showUploadInfo_code(e) {
      if ($(e.currentTarget).length == 0) {
        return;
      }
      var responseTetx = $(e.currentTarget)[0].contentDocument.body.textContent;
      if (responseTetx) {
        var responseJsonObj = JSON.parse(responseTetx);
        if (responseJsonObj.status == true) {

          alert(responseJsonObj.msg)

          var resTempArray = new Array();
          var resTempObj = new Object();
          for (var i = 0; i < responseJsonObj.data.length; i++) {
            var oneObj = responseJsonObj.data[i];
            if (!resTempObj[oneObj]) {
              resTempArray.push(oneObj);
              resTempObj[oneObj] = 1;
            }
          }
          this.uploadStockCodeArray = resTempArray;
          $(".stockCodeSelect_div input").val(resTempArray.join());
          $(".stockCodeSelect_div input").attr("title", resTempArray.join());
        } else {
          if (responseJsonObj.msg = "文件太大") {
            this.errorInfoArray = "文件上传失败！请上传小于1M的文件！";
            $("#errorInfoModal").modal();
          } else {
            this.errorInfoArray = "文件上传失败！请确认文件内容是否正确！";
            $("#errorInfoModal").modal();
          }
        }
      }
    },
    uploadFile: function () {
      var fileName = $("#uploadfile").val();
      if (
          fileName.indexOf(".txt") > 0 ||
          fileName.indexOf(".TXT") > 0 ||
          fileName.indexOf(".xls") > 0 ||
          fileName.indexOf(".XLS") > 0 ||
          fileName.indexOf(".xlsx") > 0 ||
          fileName.indexOf(".XLSX") > 0
      ) {
        $("#uploadFile_form").submit();
      } else if (fileName != "") {
        this.errorInfoArray = "您上传的文件格式有误！";
        $("#errorInfoModal").modal();
        // alert('您上传的文件格式有误！');
      }
      $("#uploadfile").val("");
    },
    clearFileInput: function () {
      $("#uploadfile").val("");
    },
    clearKeywordsFileInput: function () {
      //如果是样本账号，不允许上传关键词
      if (this.AuthLevel === 1 || this.AuthLevel === 2) {
        this.$Message.info("你当前的账号为试用账号，暂不提供此功能哦！")
        return
      }
      $("#uploadkeywordsfile").val("");
    },
    showUploadKeywordsInfo(e) {
      if ($(e.currentTarget).length == 0) {
        return;
      }
      var responseTetx = $(e.currentTarget)[0].contentDocument.body.textContent;
      if (responseTetx) {
        var responseJsonObj = JSON.parse(responseTetx);
        if (responseJsonObj.status == true) {
          var resTempArray = new Array();
          var resTempObj = new Object();
          for (var i = 0; i < responseJsonObj.data.length; i++) {
            var oneObj = responseJsonObj.data[i];
            if (!resTempObj[oneObj]) {
              resTempArray.push(oneObj);
              resTempObj[oneObj] = 1;
            }
          }
          this.keyword = resTempArray.join()
          // $("#keywordsinput").val(resTempArray.join());
          $("#keywordsinput").attr("title", resTempArray.join());
        } else {
          if (responseJsonObj.msg === "文件太大") {
            this.errorInfoArray = "文件上传失败！文件太大，请上传小于1M的文件";
            $("#errorInfoModal").modal();
          } else if (responseJsonObj.msg === "您的关键词数量多余100个，请限定在100个以内！") {
            this.errorInfoArray = "您的关键词数量多余100个，请限定在100个以内！";
            $("#errorInfoModal").modal();
          } else {
            this.errorInfoArray = "文件上传失败！请确认文件内容是否正确！";
            $("#errorInfoModal").modal();
          }

        }
      }
      // 判断关键字是否含有空格
      if (this.keyword.indexOf(" ") > 0) {
        let s = this.keyword.replace(/\s*/g, '');
        this.keyword = s
      }
    },
    uploadKeywordsFile: function () {
      var fileName = $("#uploadkeywordsfile").val();
      if (
          fileName.indexOf(".txt") > 0 ||
          fileName.indexOf(".TXT") > 0 ||
          fileName.indexOf(".xls") > 0 ||
          fileName.indexOf(".XLS") > 0 ||
          fileName.indexOf(".xlsx") > 0 ||
          fileName.indexOf(".XLSX") > 0
      ) {
        $("#uploadKeywordsFile_form").submit();
      } else if (fileName != "") {
        this.errorInfoArray = "您上传的文件格式有误！";
        $("#errorInfoModal").modal();
        // alert('您上传的文件格式有误！');
      }
      $("#uploadkeywordsfile").val("");
    },
    enter: function (el, done) {
      var Velocity = require('velocity-animate')
      Velocity(el, "slideDown", {duration: 300});
    },
    leave: function (el, done) {
    },
    removeAllStockCode() {
      if (this.stockCodeSelect_serach === "") {
        this.stockCode_name_selected_Array = [];
        this.stockCode_nameArray = this.stockCode_allJsonData_array;
      } else {
        if (
            $(
                ".stockCode_selected_div .oneSelectOption_div:first-child"
            ).text() !== "未匹配到相应证券"
        ) {
          this.stockCode_nameArray = this.stockCode_nameArray.concat(
              this.stockCode_selected_temporaryArray
          );
          var tempArray = this.stockCode_name_selected_Array;
          for (
              var i = 0;
              i < this.stockCode_selected_temporaryArray.length;
              i++
          ) {
            var code = this.stockCode_selected_temporaryArray[i].code;
            tempArray = tempArray.filter(s => s.code !== code);
          }
          this.stockCode_name_selected_Array = tempArray;
          this.stockCode_selected_temporaryArray = [];
        }
      }
    },
    selectAllField() {
      $(".checkedFont_selectAll").css("opacity", "1");
      $(".checkedFont_removeAll").css("opacity", "0");
      if (this.unSelect_serach === "") {
        if (this.$route.params.viewname === "CFND_HighTrail") {
          this.selectedField = this.unselectedField;
        } else {
          this.selectedField = this.currentTableInfoFields.map(function (s) {
            return {FieldName: s.key, DisplayName: s.title}
          });
        }
        this.unselectedField = [];
      } else {
        if (
            $(
                ".field-select-unselect .field-select-fieldlist li:first-child"
            ).text() !== "未匹配到相应字段"
        ) {
          this.selectedField = this.selectedField.concat(this.unselectedField);
          this.unselectedField = [];
        }
      }
    },
    changeDate: function (e, type) {
      if (type == "startdate") {
        this.minDate = e;
        $("#enddate").val("");
        // this.allSelectCondition.StartDate = $("#startDate").val();
      } else {
        this.maxDate = e;
        // this.allSelectCondition.EndDate = $("#enddate").val();
      }
    },

    information_first() {
      //第一步隐藏
      $("#model_first").modal('hide');
      //打开第二步
      $("#model_second").modal();
    },
    second_next() {
      var result = this.validPhone();
      if (result) {
        $("#phoneTip").hide();
        if (this.form_second.code.trim().length == 6) {
          $("#codeTip").hide();
          axios.post("/api/register/valCodeByRedis", {
            code: this.form_second.code.trim(),
            phone: this.form_second.phone.trim()
          }).then((res) => {
            if (res.data.status) {
              //第二步隐藏
              $("#model_second").modal('hide');
              //打开第三步
              $("#model_third").modal();
              $("#codeTip").hide();
            } else {
              $("#codeTip").show();
            }
          });
        } else {
          $("#codeTip").show();
        }

      } else {
        $("#phoneTip").text("* 手机号格式错误");
        $("#phoneTip").show();
      }
    },

    validPhone() {
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!reg.test(this.form_second.phone.trim())) {
        return false;
      } else {
        return true;
      }
    },

    valPhone: globalFunction.debounce(function () {
      var result = this.validPhone();
      if (result) {
        let formData = new FormData();
        formData.append("phone", this.form_second.phone.trim());
        axios({
          method: 'post',
          url: '/api/register/valPhone',
          data: formData,
        }).then((res) => {
          if (res.data.status) {
            $("#phoneTip").hide();
          } else {
            $("#phoneTip").text(res.data.msg);
            $("#phoneTip").show();
          }
        });
      } else {
        $("#phoneTip").text("* 手机号格式错误");
        $("#phoneTip").show();
      }
    }, 1000),


    async sendPhone() {
      var result = this.validPhone();
      if (result) {
        $("#phoneTip").hide();
        await axios.post("/api/register/sendPhoneMessageByredis", {
          phone: this.form_second.phone.trim()
        }).then((res) => {
          if (res.data.status) {
            $('#button1')[0].disabled = true
            // 发送短信后启动定时器
            this.setTime = setInterval(() => {
              //console.log(this.time)
              if (this.time > 0) {
                this.time--
              }
              if (this.time === 0) {
                $('#button1')[0].disabled = false
                clearInterval(this.setTime)
                this.time = 60
              }
            }, 1000);
            $("#phoneTip").hide();
          } else {
            $("#phoneTip").text(res.data.msg);
            $("#phoneTip").show();
          }
        }).catch(() => {
          this.$Message.error("短信发送失败")
        })

      } else {
        $("#phoneTip").text("* 手机号格式错误");
        $("#phoneTip").show();
      }
    },
    passwordTest() {
      if (this.form_third.password.trim().length <= 0) {
        $("#passwordTip").show();
      } else {
        $("#passwordTip").hide();
      }
    },
    emailTest() {
      if (this.form_third.email.trim().length <= 0) {
        $("#emailTip").show();
      } else {
        const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
        if (reg.test(this.form_third.email.trim())) {
          $("#emailTip").hide();
        } else {
          $("#emailTip").show();
        }
      }
    },
    schoolTest() {
      if (this.form_third.school.trim().length <= 0) {
        $("#schoolTip").show();
      } else {
        $("#schoolTip").hide();
      }
    },
    //上一步
    lastStep() {
      $("#model_third").modal('hide');
      $("#model_second").modal();
    },
    finish() {
      if (this.form_third.password.trim().length <= 0) {
        $("#passwordTip").show();
        return;
      } else {
        $("#passwordTip").hide();
      }
      if (this.form_third.email.trim().length <= 0) {
        $("#emailTip").show();
        return;
      } else {
        const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
        if (reg.test(this.form_third.email.trim())) {
          $("#emailTip").hide();
        } else {
          $("#emailTip").show();
          return;
        }
      }
      if (this.form_third.school.trim().length <= 0) {
        $("#schoolTip").show();
        return;
      } else {
        $("#schoolTip").hide();
      }

      axios.post("/api/user/addUser", {
        phone: this.form_second.phone.trim(),
        password: this.form_third.password.trim(),
        email: this.form_third.email.trim(),
        school: this.form_third.school.trim(),
        identity: this.form_third.identity.trim()
      }).then((res) => {
        if (res.data.status) {
          //第二步隐藏
          $("#model_third").modal('hide');
          //打开第三步
          $("#model_four").modal();
        } else {
          this.$message.error('提交失败，请联系客服人员');
        }
      });

    },
    loginByNewAccount() {
      //第二步隐藏
      $("#model_four").modal('hide');
      this.gotoLogin();
    },
    loginByFirst() {
      //第二步隐藏
      $("#model_first").modal('hide');
      this.gotoLogin();
    },

  }
};
</script>
<style lang="scss">
/*滚动条类*/
.scrollbars::-webkit-scrollbar {
  width: 5px;
  height: 6px;
}

.scrollbars::-webkit-scrollbar-thumb {
  border-radius: 20px;
  //-webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.2);
  background: rgba(0, 0, 0, 0.25);
}

.scrollbars::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.2);
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}

/*通用按钮类*/
.commonbtn {
  background-color: #4184f3;
  color: white;
  border: 1px solid #4184f3;
  border-radius: 4px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.commonbtn:hover {
  background-color: #5e9bff;
  border: 1px solid #5e9bff;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.commonbtn:focus {
  outline: none;
}

/*通用按钮类*/
.commonbtnol {
  background-color: white;
  color: #4773bb;
  border: 1px solid rgba(223, 229, 240, 0.8);
  border-radius: 4px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.commonbtnol:hover {
  background-color: #4184f3;
  border: 1px solid #4184f3;
  color: white;
  transition: ease all 0.2s;
  -webkit-transition: ease all 0.2s;
  -moz-transition: ease all 0.2s;
  -ms-transition: ease all 0.2s;
}

.commonbtnol:focus {
  outline: none;
}

/* 鼠标经过表格行 */
.hoverline tbody tr {
  transition: ease all 0.2s;
  -webkit-transition: ease all 0.2s; /* Safari and Chrome */
  -moz-transition: ease all 0.2s; /* Firefox */
  -ms-transition: ease all 0.2s; /* Opera */
}

.hoverline tbody tr:hover {
  background-color: #f7f9ff;
  transition: ease all 0.1s;
  -webkit-transition: ease all 0.1s; /* Safari and Chrome */
  -moz-transition: ease all 0.1s; /* Firefox */
  -ms-transition: ease all 0.1s; /* Opera */
}

/* 查询模块卡片样式 */
.oneFunction_div {
  position: relative;
  width: 100%;
  border: 1px solid rgba(223, 229, 240, .8);
  border-radius: 4px;
  margin-bottom: 20px;
}

.reminder_div .iconfont {
  font-size: 18px;
  vertical-align: middle;
  margin-left: 5px;
  margin-right: 7px;
  font-weight: 500;
  color: #4184f3;
}

.reminder_title {
  font-style: normal;
  font-size: 17px;
  border-bottom: 1px solid rgba(223, 229, 240, .8);
  padding: 10px 15px;
  padding-bottom: 7px;
  color: #4773bb;
}

.reminder_content {
  margin: 16px 45px;
  margin-bottom: 12px;
}

/* 单选按钮 */
.radio-primary {
  display: inline-block;
  cursor: pointer;
  border: 1px solid rgba(223, 229, 240, .8);
  border-radius: 4px;
  height: 35px;
  line-height: 35px;
  min-width: 100px;
  margin-bottom: 12px;
  max-width: 150px;
  padding-right: 12px;
}

.radio-primary:focus {
  border: 1px solid #2d8cf0 !important;
  outline: none;
}

.radio-primary:focus .radio-primary label {
  color: #2d8cf0;
}

.radio-primary label {
  cursor: pointer;
  vertical-align: middle;
  font-weight: 500;
}

/* 时间范围 */
.timepicker-div {
  margin: -8px 0px 0px 28px;
  overflow: hidden;
}

.Yearselect /deep/ .ivu-select {
  position: absolute !important;
  width: 215px !important;
}

.Yearselect .ivu-select {
  position: absolute !important;
  width: 215px !important;
}

.Yearselect /deep/ .ivu-select-selection {
  height: 32px !important;
  border: none !important;
  box-shadow: none !important;
  line-height: 30px !important;
}

.Yearselect .ivu-select-selection {
  height: 32px !important;
  border: none !important;
  box-shadow: none !important;
  line-height: 30px !important;
  border-radius: 0;
}

.Yearselect /deep/ .ivu-select-placeholder {
  line-height: 35px !important;
  font-size: 12px;
}

.Yearselect .ivu-select-placeholder {
  line-height: 35px !important;
  font-size: 12px;
}

.Yearselect /deep/ .ivu-select-dropdown::-webkit-scrollbar {
  width: 5px;
}

.Yearselect .ivu-select-dropdown::-webkit-scrollbar {
  width: 5px;
}

.Yearselect /deep/ .ivu-select-dropdown::-webkit-scrollbar-thumb {
  border-radius: 20px;
  //-webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.2);
  background: rgba(0, 0, 0, 0.25);
}

.Yearselect .ivu-select-dropdown::-webkit-scrollbar-thumb {
  border-radius: 20px;
  //-webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.2);
  background: rgba(0, 0, 0, 0.25);
}

.Yearselect /deep/ .ivu-select-dropdown::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.2);
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}

.Yearselect .ivu-select-dropdown::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.2);
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}

.Yearselect /deep/ .clearoptions {
  text-align: center;
  color: rgb(199, 200, 208);
  border-radius: 4px;
  display: inline-block;
  height: 25px;
  width: 50px;
  position: relative;
  left: 135px;
  top: 5px;
  padding: 0px;
  margin: 0px;
  background-color: inherit;
  line-height: 22px;
  border: none;
  font-size: 12px;
}

.Yearselect .clearoptions {
  text-align: center;
  color: rgb(199, 200, 208);
  border-radius: 4px;
  display: inline-block;
  height: 25px;
  width: 50px;
  position: relative;
  left: 135px;
  top: 5px;
  padding: 0px;
  margin: 0px;
  background-color: inherit;
  line-height: 22px;
  border: none;
  font-size: 12px;
}

.Yearselect /deep/ .clearoptions:hover {
  background-color: #fafafa;
  color: #515A6E;
}

.Yearselect .clearoptions:hover {
  background-color: #fafafa;
  color: #515A6E;
}

.Yearselect /deep/ .clearoptions:hover .clearoi {
  color: #515A6E !important;
}

.Yearselect .clearoptions:hover .clearoi {
  color: #515A6E !important;
}

.Yearselect /deep/ .clearoptions:focus {
  outline: none !important;
}

.Yearselect .clearoptions:focus {
  outline: none !important;
}

.yeardatepickr /deep/ .ivu-input {
  padding-right: 32px !important;
  padding-left: 10px;
  border: none;
  box-shadow: none;
}

.yeardatepickr .ivu-input {
  padding-right: 32px !important;
  padding-left: 10px;
  border: none;
  box-shadow: none;
}

.yeardatepickr /deep/ .ivu-input-suffix {
  width: 40px;
}

.yeardatepickr .ivu-input-suffix {
  width: 40px;
}

.Yearselect /deep/ .ivu-select-disabled .ivu-select-selection {
  background-color: #fafafa;
  cursor: default;
}

.Yearselect .ivu-select-disabled .ivu-select-selection {
  background-color: #fafafa;
  cursor: default;
}

.reminder_content /deep/ ivu-picker-panel-body {
  z-index: 1000 !important;
}

.reminder_content ivu-picker-panel-body {
  z-index: 1000 !important;
}

.icon-nian {
  color: #ccc !important;
  margin-left: 3px !important;
}

.timepicker {
  height: 35px;
  width: 200px;
  float: left;
  border: 1px solid rgba(223, 229, 240, .8);
  border-radius: 3px;
}

.timepicker-header {
  height: 33px;
  float: left;
  width: 45px;
  padding: 0px 10px;
  background: #FAFAFA;
  text-align: center;
  border-right: 1px solid rgba(223, 229, 240, 0.8);
  color: #ccc;

  & > span {
    line-height: 32px;
    height: 35px;
    float: left;
    vertical-align: middle;
  }
}

.timepicker-input {
  overflow: hidden;
  height: 32px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;

  input {
    padding: 0px 8px;
    border: none;
    outline: none;
    color: #515a6e;
    cursor: pointer;
    transition: ease all 0.4s;
    -webkit-transition: ease all 0.4s;
    -moz-transition: ease all 0.4s;
    -ms-transition: ease all 0.4s;
  }
}

input[type="radio"], input[type="checkbox"] {
  line-height: normal;
  margin-left: 11px;
  margin-right: 3px;
  cursor: pointer;
}

input::-webkit-input-placeholder {
  /* WebKit browsers */
  font-size: 11px;
  color: #ccc;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 11px;
  color: #ccc;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 11px;
  color: #ccc;
}

input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  font-size: 11px;
  color: #ccc;
}

.icon-riqi {
  color: #ccc !important;
  font-size: 14px !important;
  position: relative;
  top: -27px;
  left: 122px;
}

.icon-riqi {
  color: #ccc !important;
  font-size: 14px !important;
  position: relative;
  top: -27px;
  left: 122px;
}

.ivicon {
  color: #808695 !important;
  position: relative;
  top: -31px;
  left: 127px;
  font-size: 16px;
  line-height: 32px;
}

.icon-kaishishijian, .icon-jieshushijian {
  color: #ccc !important;
  font-size: 14px !important;
  position: relative;
  top: -26px;
  left: -10px;
}

/* 时间范围模块提示文字 */
.tip {
  font-size: 11px;
  color: #4773bb;
  font-weight: 500;
  margin-top: 20px;
}

.tipleft {
  float: left;
  position: relative;
  left: -30px;
}

.tipright {
  float: right;
  position: relative;
  right: -30px;
}

.underline {
  text-decoration: underline;
}

/* 代码选择穿梭框 */
.field-select-fieldlist {
  height: 245px;
  overflow: hidden;
  margin-top: 10px;

  li {
    padding-left: 15px;
    width: 100%;
    border-bottom: 1px solid rgba(223, 229, 240, 0.8);
    cursor: pointer;
    height: 32px;
    line-height: 32px;

    &:first-child {
      border-top: 1px solid rgba(223, 229, 240, 0.8);
    }

    &:hover {
      background-color: #f2f7fe;
    }
  }
}

.ivu-alert-info {
  border: 1px solid #c4d6ff;
  background-color: #f2f6ff;
}

.field-select-fieldlist:hover {
  overflow: auto;
}

ul {
  padding-left: 10px;

  li {
    list-style: none;
    padding-top: 1px;
  }
}

.field-select-search {
  /* width: 100%; */
  border: 1px solid rgba(223, 229, 240, 0.8);
  overflow: hidden;
  position: relative;
  margin: 10px;
  border-radius: 3px;

  & > input {
    border: none;
    width: 100%;
    height: 32px;
    line-height: 32px;
    overflow: hidden;
    float: left;
    padding-left: 15px;
    padding-right: 25px;
  }

  & > span {
    position: absolute;
    cursor: pointer;
    right: 2px;
    float: right;
    height: 35px;
    line-height: 35px;
    font-weight: 600 !important;
  }
}

.field-select-search input:focus {
  outline: none !important;
  box-shadow: none !important;
}

.fieldSelect_body_div {
  //width: 800px;
  margin: 15px 45px;
}

.fieldSelect_content_div {
  & > div {
    float: left;
    width: 48%;

    & + div {
      margin-left: 15px;
    }
  }
}

.field-select-header {
  padding-left: 12px;
  width: 100%;
  overflow: hidden;

  span {
    vertical-align: middle;
    height: 35px;
    line-height: 28px;
  }

  & > button {
    float: right;
    height: 32px;
    background-color: white;
    color: #515a6e;
    border-radius: 6px;
    outline: none;
    font-size: 12px;
    padding: 0px 13px;
    border: none;
  }

  & > button:hover {
    color: rgba(0, 0, 0, .85);
    background: rgba(0, 0, 0, .018);
    border-color: transparent;
  }
}

/* 穿梭框左侧选项 */
.oneSelectOption_div,
.oneSelectedOption_div {
  height: 35px;
  border-top: 1px solid rgba(223, 229, 240, 0.8);
  text-align: center;
  line-height: 35px;
  cursor: pointer;
  font-size: 12px;
}

.oneSelectedOption_div:hover,
.oneSelectOption_div:hover {
  background: #f2f7fe;
  color: #4184f3;
}

.oneSelectOption_div:first-child {
  border-top: 0px;
}

.oneSelectedOption_div:first-child {
  border-top: 0px;
}

.oneSelectOption_div:last-child {
  border-bottom: 1px solid rgba(223, 229, 240, 0.8);
}

.oneSelectedOption_div:last-child {
  border-bottom: 1px solid rgba(223, 229, 240, 0.8);
}

.icon-jiaohuan {
  position: absolute;
  left: 330px;
  top: 200px;
  font-size: 32px !important;
  color: rgba(65, 132, 243, 0.35) !important;
}

.stockCodeSelect_div {
  width: 300px !important;
  height: 35px !important;
  border: 1px solid #ccc;
  margin-left: 28px;
  float: left;
}

.add-stockSelect-button {
  height: 35px;
  width: 35px;
  border-radius: 35px;
  border: 0px;
  background: #347abf;
  margin-left: 25px;
  outline: none;
  cursor: pointer;
  position: relative;
  // background: url("../assets/index/add.png") no-repeat;
}

.condition_head_table {
  width: 100%;
  border: 1px solid #ccc;

  th,
  td {
    border-right: 1px solid #ccc;
  }

  tr {
    border-bottom: 1px solid #ccc;
  }
}

.stockCodeSelect_inputAndButton_div {
  width: 700px !important; // display: none;
}

.stockCodeInput_inputAndButton_div {
  width: 100% !important;
  display: none;
}

.downloadtemplate {
  float: right;
  position: absolute;
  right: 45px;
  top: 165px;
}

.downloadtemplate a {
  color: #515a6e;
  opacity: .7;
  width: 100px;
  display: inline-block;
  text-align: center;
  height: 30px;
  line-height: 28px;
  border: 1px solid rgba(223, 229, 240, 1);
  border-radius: 4px;
  font-size: 14px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.downloadtemplate a:hover {
  color: #4184f3;
  border: 1px solid #4184f3;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.downloadtemplate a:focus {
  color: #4184f3;
  border: 1px solid #4184f3;
  outline: none;
  text-decoration: none;
}

.function_condition_setting_div .oneFunction-header:hover {
  background-color: #dceefb !important;
  /*color:white;*/
}

.stockCodeSelect_select_body {
  width: 700px;
  margin: 0 auto;
  height: 100%;
  position: relative;
}

all_stockCode_name_div {

}

.all_stockCode_name_div,
.stockCode_selected_div {
  height: 340px;
  width: 320px;
  float: left;
  border-radius: 5px;
  border: 1px solid rgba(223, 229, 240, 0.8);
  margin-bottom: 12px;
  /*box-shadow: 0 1px 6px 0 rgba(0,0,0,.12), 0 1px 6px 0 rgba(0,0,0,.12)*/
}

.ico_right_div {
  position: absolute;
  left: 350px;
  /*top: 125px;*/
  height: 300px;
  width: 1px;
  background: #ccc;
}

.select_head_div {
  width: 100%;
  height: 35px;
  background: #4184f3;
  padding-left: 15px;
  color: white;
  font-size: 14px;
  line-height: 35px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.stockCode_name_body_div,
.selected_body_div {
  height: 249px;
  width: 100%;
  overflow: auto;
  margin-bottom: 10px;
  border-top: 1px solid rgba(223, 229, 240, 0.35);
}


.stock_loading_div {
  text-align: center;
  height: 100%;
  position: relative;

  i {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -25px;
  }
}


/* 未改动 */
$btncolor: #5292c4;
$border-liner: 1px solid $btncolor;
$border-bold-liner: 2px solid rgb(75, 68, 68);
.add-keywords-button {
  width: 139px;
  height: 32px;
  font-weight: 500;
  text-align: center;
  line-height: 30px;
  margin-bottom: 0px;
  cursor: pointer;
  background-color: white;
  color: #515A6E;
  border: 1px solid rgba(223, 229, 240, 0.8);
  border-radius: 4px;
  font-size: 12px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
  display: inline-block;
}

.add-keywords-button:hover {
  background-color: white;
  color: #4184f3;
  border: 1px solid #4184f3;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.moreFunction_div {
  width: 100%;
  border: 1px solid #ccc;
  min-height: 400px;
  position: relative;
  margin: 40px 0px;
}

.simpledata_table, .preview_simpledata_table {
  width: 100%;
}

/* 固定表头 */
.stickythead {
  border-top: none !important;
}

.stickythead th {
  position: sticky;
  top: 0;
  background: #ecf2fe;;
}

.theadDivBox th {
  background: #ecf2fe;
  white-space: nowrap;
  padding: 0 10px;
  height: 30px;
  border-top: none !important;
}

.table-bordered > thead > tr > th, .table-bordered > tbody > tr > th, .table-bordered > tfoot > tr > th, .table-bordered > thead > tr > td, .table-bordered > tbody > tr > td, .table-bordered > tfoot > tr > td {
  border: 1px solid rgba(223, 229, 240, 0.8);
}

.tbodyDiv {
  background: #fff;
}

.tbodyDiv tr {
  height: 25px;
}

.tbodyDiv td {
  white-space: nowrap;
  padding: 0 10px;
}


.table-footer {
  margin-top: 0px;
  margin-bottom: 20px;
  float: right;
}

#previewbtn {
  width: 115px;
  height: 40px;
  background: white;
  color: #515A6E;
  border: 1px solid rgba(223, 229, 240, 0.8);
  border-radius: 30px;
  font-size: 16px;
  margin-right: 15px;
}

#previewbtn:after {
  content: '数据预览';
  font-size: 90%;
  margin-left: 2px;
}

#previewbtn:hover, #previewbtn:focus {
  background: #4184f3;
  color: white;
  border: 1px solid #4184f3;
}

#bownloadbtn {
  width: 40px;
  height: 40px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
  background: white;
  color: #4184f3;
  border: 1px solid rgba(223, 229, 240, 0.8);
  font-size: 18px;
  font-weight: 700;
}

#bownloadbtn:hover {
  background: #4184f3;
  color: white;
  border: 1px solid #4184f3;
  width: 90px;
  border-radius: 30px;
  transition: ease all 0.3s;
  -webkit-transition: ease all 0.3s;
  -moz-transition: ease all 0.3s;
  -ms-transition: ease all 0.3s;
}

#bownloadbtn:hover::after {
  content: '下载';
  font-size: 14px;
  position: relative;
  top: -2px;
  animation: myfirst 0.4s;
  -webkit-animation: myfirst 0.4s; /* Safari and Chrome */
  -moz-animation: myfirst 0.4s; /* Firefox */
  -o-animation: myfirst 0.4s; /* Opera */
}

#bownloadbtn:focus {
  width: 90px;
  border-radius: 30px;
  background: #4184f3;
  color: white;
  border: 1px solid #4184f3;
}

#bownloadbtn:focus::after {
  content: '下载';
  font-size: 14px;
  position: relative;
  top: -2px;
}

@keyframes myfirst {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes myfirst /* Firefox */
{
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes myfirst /* Safari and Chrome */
{
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes myfirst /* Opera */
{
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


.PreviewLoading_div {
  text-align: center;
  height: 380px;
  position: relative;

  i {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -25px;
  }
}

.downloadSummary_div {
  //width: 965px;
  // min-height: 250px;
  margin: 0 auto;
}

.downloadSummary_top_div {
  height: 40px;
  width: 115px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
}

.downloadSummary_table_div {
  width: 100%;
  border: 1px solid #f0f0f0;
}

.downloadSummary_table tr {
  border-bottom: 1px #c1c1c1 solid;
}

.title_td {
  padding: 16px 24px;
  color: #4773bb;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5715;
  text-align: start;
  white-space: nowrap;
  border-right: 1px solid rgba(223, 229, 240, 0.8);
}

.value_td {
  padding: 16px 13px;
  border-right: 1px solid rgba(223, 229, 240, 0.8);
  display: table-cell;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  line-height: 1.5715;
  word-break: normal;
  overflow-wrap: break-word;
  color: #4773bb;
}

.download_bottomInfo_div {
  margin: 0 auto;
  height: 40px;
  width: 50%;
  margin-top: 30px;
}

.addToDownList {
  height: 38px;
  margin-top: 10px;
  margin-bottom: 10px;
  float: right;
}

.download_button {
  width: 135px;
  height: 38px;

}

.preview_sampleData_table_div {
  /*width:1100px;
    height: 480px; */
  overflow: auto;
  max-height: 380px;
  max-width: 1120px;
}

.beginDate_div {
  float: left;
  border: 2px $btncolor solid;
  margin-right: 20px;
  color: white;
}

.endDate_div {
  float: left;
  border: 2px $btncolor solid;
  color: white;
}

.radio_btn {
  display: inline-block;
  width: 14px !important;
  height: 14px !important;
  border-radius: 30px;
  border: 1px solid #0e76bc;
  position: relative;
  vertical-align: middle;
  top: -2px;
}

.radio_btn input {
  width: 100%;
  height: 100%;
  position: absolute;
  top: -5px;
  left: 0;
  z-index: 100;
  opacity: 0;
}

.radio_btn span {
  background: black;
  width: 14px;
  height: 14px;
  display: inline-block;
  position: absolute;
  z-index: 15;
  top: -1px;
  left: -1px;
  border-radius: 10px;
  background: #5eb346;
}

.radio_btn input[type="radio"] + span {
  opacity: 0;
}

.radio_btn input[type="radio"]:checked + span {
  opacity: 1;
}

#keywordsinput {
  width: 465px;
  height: 32px;
  line-height: 32px;
  border: 1px solid rgba(223, 229, 240, 0.8);
  padding-left: 10px;
  border-radius: 4px 0 0 4px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
  display: inline-block;
  vertical-align: bottom;
}

#keywordsinput:hover {
  border: 1px solid rgba(65, 132, 243, .8);
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

#keywordsinput:focus {
  outline: none;
  border: 1px solid rgba(65, 132, 243, .8);
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}

.inquirebtn {
  height: 32px;
  width: 70px;
  font-size: 15px;
  border-radius: 0 5px 5px 0;
}

.inquirebtn2 {
  height: 32px;
  width: 140px;
  font-size: 15px;
  margin-left: 1%;
  margin-right: 1%;
  border-radius: 5px 5px 5px 5px;
  position: absolute;
}

.inquirebtn3 {
  height: 32px;
  width: 70px;
  font-size: 15px;
  border-radius: 5px 5px 5px 5px;
  margin-left: 157px;
  position: absolute;
}

@media (min-width: 1560px) {
  .fieldSelect_content_div {
    & > div {
      float: left;
      width: 48%;

      & + div {
        margin-left: 15px;
      }
    }
  }
}

@media (min-width: 1420px) {
  @media (max-width: 1560px) {
    .fieldSelect_content_div {
      & > div {
        float: left;
        width: 48%;

        & + div {
          margin-left: 15px;
        }
      }
    }
  }
}

//
@media (min-width: 1220px) {
  @media (max-width: 1420px) {
    .fieldSelect_content_div {
      & > div {
        float: left;
        width: 47%;

        & + div {
          margin-left: 15px;
        }
      }
    }
  }
}

@media (min-width: 1000px) {
  @media (max-width: 1220px) {
    .fieldSelect_content_div {
      & > div {
        float: left;
        width: 46%;

        & + div {
          margin-left: 15px;
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .fieldSelect_content_div {
    & > div {
      float: left;
      width: 45%;

      & + div {
        margin-left: 15px;
      }
    }
  }
}

.aaaa {
  position: relative;
}

.ivu-steps-head {
  height: 28px;
  padding-right: 5px;
}

.aaaa /deep/ .ivu-chart-circle {
  position: absolute !important;
  left: -46px !important;
  top: -23px !important;
  z-index: 999;
}

.ivu-chart-circle {
  position: absolute !important;
  left: -46px !important;
  top: -23px !important;
  z-index: 999;
}

.aaaa /deep/ .ivu-steps-head-inner {
  width: 32px;
  height: 32px;
  line-height: 32px;
  margin-top: 6px;
  margin-left: 6px;
}

.aaaa /deep/ .ivu-icon-ios-checkmark {
  font-size: 32px !important;
  margin-top: -1px !important;
  margin-left: -1px !important;
}

.aaaa /deep/ .ivu-steps-content {
  color: #999;
  margin-left: 12px !important;
}

.aaaa /deep/ .ivu-steps-tail > i {
  margin-top: 8px;
}

.aaaa /deep/ .ivu-steps-title {
  margin-top: 10px !important;
}

.aaaa /deep/ .ivu-spin-fix {
  position: relative !important;
  top: 15px;
  left: 15px;
  background-color: rgba(255, 255, 255, 0);
}

.aaaa /deep/ .ivu-spin-fix .ivu-spin-main {
  position: relative !important;
  left: 0px !important;
}

.loader {
  width: 30px;
  height: 30px;
  position: relative;
  margin: 0 auto;
  top: 12px;
}

.ivu-steps-item {
  padding-top: 10px;
}

.ivu-steps .ivu-steps-tail {
  margin-top: 8px;
}

.ivu-steps .ivu-steps-head {
  margin-left: 0px !important;
  padding-left: 10px !important;
}

.ivu-steps-horizontal .ivu-steps-content {
  padding-left: 47px;
}

.circular {
  -webkit-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;
  height: 100%;
  -webkit-transform-origin: center center;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto
}

.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  -webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round
}

@-webkit-keyframes rotate {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes rotate {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35
  }

  to {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35
  }

  to {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124
  }
}

@-webkit-keyframes color {

  0%,
  to {
    stroke: #d62d20
  }

  40% {
    stroke: #0057e7
  }

  66% {
    stroke: #008744
  }

  80%,
  90% {
    stroke: #ffa700
  }
}

@keyframes color {

  0%,
  to {
    stroke: #d62d20
  }

  40% {
    stroke: #0057e7
  }

  66% {
    stroke: #008744
  }

  80%,
  90% {
    stroke: #ffa700
  }
}

.rolelogin {
  border-bottom: 1px dashed #000;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s; /* Safari and Chrome */
  -moz-transition: ease all 0.4s; /* Firefox */
  -ms-transition: ease all 0.4s; /* Opera */
}

.rolelogin:hover {
  border-bottom: 1px solid #4184f3;
  color: #4184f3;
  cursor: pointer;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s; /* Safari and Chrome */
  -moz-transition: ease all 0.4s; /* Firefox */
  -ms-transition: ease all 0.4s; /* Opera */
}

.asterisk {
  padding-right: 10px;
  vertical-align: sub;
}

.alertclass /deep/ .ivu-alert-with-desc .ivu-alert-message {
  color: #4773bb;
  border-bottom: 1px solid #c4d6ff;
  padding-bottom: 8px;
}

.alertclass /deep/ .ivu-alert-info {
  padding-top: 10px;
}

.yearButton {
  display: none !important;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
</style>

